import { useEffect, useRef } from 'react';

import './styles.scss';
// import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const handleNodes = (root, filters, type, ref) => {
  root.forEach((el) => el.classList.add('hidden'));
  filters.forEach((name) => {
    const selected = ref.current.querySelectorAll(`.${name}`);
    console.log('Showing elements for', name, selected);
    selected.forEach((el) => el.classList.remove('hidden'));
  });
};

export const Map = ({ filterList, isHighlight, isShowCircle }) => {
  const ref = useRef(null);
  // const history = useHistory();
  // const [isWinCityHovered, setIsWinCityHovered] = useState(false);
  const {
    'tien-ich': currentAmenitiesFilters,
    'giao-thong': currentTrafficFilters,
  } = filterList;

  useEffect(() => {
    const showElements = () => {
      const allTienIch = ref.current.querySelectorAll('.amenity');
      const allGiaoThong = ref.current.querySelectorAll('.road');

      if (currentAmenitiesFilters.length === 0) {
        // allTienIch.forEach((el) => el.classList.remove('hidden'));
        allTienIch.forEach((el) => el.classList.add('hidden'));
      } else {
        console.log('Handling nodes for amenities');
        handleNodes(allTienIch, currentAmenitiesFilters, 'tien-ich', ref);
      }

      if (currentTrafficFilters.length === 0) {
        allGiaoThong.forEach((el) => el.classList.remove('hidden'));
      } else {
        handleNodes(allGiaoThong, currentTrafficFilters, 'giao-thong', ref);
      }
    };

    if (ref.current) {
      showElements();
    }
  }, [currentAmenitiesFilters, currentTrafficFilters]);

  useEffect(() => {
    const distanceCircles = ref.current.querySelectorAll('.distance-circle');
    if (isShowCircle) {
      distanceCircles.forEach((circle) => {
        circle.classList.remove('hidden');
      });
    } else {
      distanceCircles.forEach((circle) => {
        circle.classList.add('hidden');
      });
    }
  }, [isShowCircle]);

  useEffect(() => {
    const mainRoads = ref.current.querySelectorAll('.main-road > path');
    const secondaryRoads = ref.current.querySelectorAll(
      '.secondary-road > path'
    );
    const allTienIch = ref.current.querySelectorAll('.amenity');
    const movingLine = ref.current.querySelectorAll('.moving-line');
    console.log({ mainRoads, secondaryRoads, allTienIch, movingLine });
    // const roadBack = ref.current.querySelector('.road-back-drop');
    if (isHighlight) {
      allTienIch.forEach((el) => {
        el.classList.remove('highlight-invisible');
      });
      mainRoads.forEach((mainRoad) => {
        mainRoad.setAttribute('stroke', '#A4854C');
        mainRoad.classList.add('highlight');
      });
      secondaryRoads.forEach((secondaryRoad) => {
        secondaryRoad.setAttribute('stroke', '#e1d0b4');
        secondaryRoad.classList.add('highlight');
      });
      movingLine.forEach((line) => {
        line.classList.add('highlight');
      });
      // roadBack.classList.add('highlight');
    } else {
      allTienIch.forEach((el) => {
        el.classList.add('highlight-invisible');
      });
      mainRoads.forEach((mainRoad) => {
        mainRoad.setAttribute('stroke', '#A7A9AC');
        mainRoad.classList.remove('highlight');
      });
      secondaryRoads.forEach((secondaryRoad) => {
        secondaryRoad.setAttribute('stroke', '#d6d6d6');
        secondaryRoad.classList.remove('highlight');
      });
      movingLine.forEach((line) => {
        line.classList.remove('highlight');
      });
      // roadBack.classList.remove('highlight');
    }
  }, [isHighlight]);

  return (
    <div className="lien-ket-vung-map">
      {/* <img className="map__backdrop" src={MapBg} alt="" /> */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        viewBox="0 0 897.5 456"
        width="897"
        height="456"
        ref={ref}
      >
        <defs>
          <pattern
            id="logo-image-pattern"
            patternUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <image
              href="/assets/images/logo/aurora-favicon.webp"
              x="3"
              y="3"
              width="20"
              height="20"
              preserveAspectRatio="xMidYMid slice"
            />
          </pattern>
          <radialGradient
            id="radial-gradient"
            cx="484.8"
            cy="1228.5"
            fx="484.8"
            fy="1228.5"
            r="14.8"
            gradientTransform="translate(0 344.5) scale(1 -.2)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient1"
            cx="484.8"
            cy="1874.7"
            fx="484.8"
            fy="1874.7"
            r="8.8"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient2"
            cx="484.8"
            cy="1874.7"
            fx="484.8"
            fy="1874.7"
            r="4"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient3"
            cx="185.8"
            cy="1168.4"
            fx="185.8"
            fy="1168.4"
            r="15.4"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient4"
            cx="185.8"
            cy="1168.4"
            fx="185.8"
            fy="1168.4"
            r="9.1"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient5"
            cx="185.8"
            cy="1168.4"
            fx="185.8"
            fy="1168.4"
            r="4.1"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient6"
            cx="395.7"
            cy="1533.1"
            fx="395.7"
            fy="1533.1"
            r="15.4"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient7"
            cx="395.7"
            cy="1533.1"
            fx="395.7"
            fy="1533.1"
            r="9.1"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient8"
            cx="395.7"
            cy="1533.1"
            fx="395.7"
            fy="1533.1"
            r="4.1"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient9"
            cx="664.5"
            cy="1435.6"
            fx="664.5"
            fy="1435.6"
            r="15.4"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient10"
            cx="664.5"
            cy="1435.6"
            fx="664.5"
            fy="1435.6"
            r="9.1"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient11"
            cx="664.5"
            cy="1435.6"
            fx="664.5"
            fy="1435.6"
            r="4.1"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient12"
            cx="810.3"
            cy="1468.9"
            fx="810.3"
            fy="1468.9"
            r="15.4"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient13"
            cx="810.3"
            cy="1468.9"
            fx="810.3"
            fy="1468.9"
            r="9.1"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
          <radialGradient
            id="radial-gradient14"
            cx="810.3"
            cy="1468.9"
            fx="810.3"
            fy="1468.9"
            r="4.1"
            gradientTransform="translate(0 455.9) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#4c1517" />
            <stop offset="0" stop-color="#592627" />
            <stop offset="0" stop-color="#7b5354" />
            <stop offset=".1" stop-color="#9a7c7d" />
            <stop offset=".2" stop-color="#b69fa0" />
            <stop offset=".3" stop-color="#ccbdbd" />
            <stop offset=".4" stop-color="#dfd5d5" />
            <stop offset=".5" stop-color="#ede8e8" />
            <stop offset=".6" stop-color="#f7f5f5" />
            <stop offset=".7" stop-color="#fdfcfc" />
            <stop offset="1" stop-color="#fff" />
          </radialGradient>
        </defs>

        <g class="st13">
          <g id="Layer_1">
            <g id="LAND">
              <path
                class="st37"
                d="M882,308.4s-11.4-1.2-15.6-9.5-10-21-8.9-25.7c0,0-.2-11.6,1-14.9s4.2-9.6,8.5-10.6,14.1-3.7,14.1-3.7l1.2-36.3s-19.5-5.6-21.2,1,1.2,10.4-2.3,17.4-.6,9.3-1.9,11.6-8.9-.6-11-5.8-3.1-10.2-3.1-10.2c0,0,7.1-4.2,7.3-9.8s-2.7-11.8,1.5-14.5c.8-6.4,1.2-7.3,3.7-8.9s-2.7-12.2-2.5-14.1-7.1-17.8-3.5-23.5,8.7-13.5,8.7-13.5c0,0-9.2,2.2-13.6,1s-4.4-3.6-4.9-6.3-2.7-3.2-5.4-4.4-2.7-1.9-2.7-3.4,8.5-7.3,12.7-11.2,2.9-3.7,6.1-5.1,6.3-3.2,6.3-3.2c0,0-8.8-3.7-12.7-7.3l-7.8-7.3-16.1-2.2-1-7.3-10.7-7.8-20,4.6-7.1-2.4-1.2-6.6s8.3-4.4,16.5-5.1c9.7-6.1,14.4-9,14.4-11.9-5.4-.5-13.1,0-14.8.5-2-3.2-3.7-4.9-3.7-4.9l-23.9,17-16.1,3.2-2.9,4.4-5.1.7-2-3.9s-4.4,1.5-3.4,4.6,1.7,6.3-1.7,7.1-8.5,3.4-10.2,6.8,3.9,15.6,6.6,18.5,8.3,10.2,8.3,10.2l-4.9,2.7s-14.6-14.6-15.8-15.1-6.8.2-6.8.2c0,0-2.7,10.7-4.6,15.3s-3.2,17.5-3.2,17.5c0,0-7.3,2.2-8.5,1.2s-3.7-4.6-3.7-4.6c0,0-17,2.2-18.8,2.1s-3.9.4-4.5-1-3.5-5.5-3.5-5.5l-2.5,1s1,5.6.8,8.7-.4,4.5,1.7,4.8,3,.7,3,.7v3.1c-.1,0-3.2-.3-3.7,1.3s.7,3.5.7,3.5c0,0-4.2,1.3-5.3,2.1s-.8,5.5-.8,5.5c0,0,.1,2.7-.6,3.6s-2.8,5.5-2.8,5.5c0,0,7.4,0,8.1.1s.1,2.9,1.3,3.2,3.8,1.1,3.8,1.1l-2.4,6s5.9.6,8.8-.1,4.8-.8,4.8-.8c0,0-2.4-8-1-8.7s4.1-1.1,4.1-1.1c0,0,6.5,16.2,14.7,20.2,4.5,2.9,4.1,4.6,4.1,4.6l-4.8-.7-7.2-.7-2.9-4.1,1.9-2s-2.9-3.7-3.4-3.8-2.6,2-2.6,2l-.7-2.6s-10.3.9-12.1,1.2-3.1,1.5-3.7.1-1.4-1.8-3.5-1.6-4.9.4-6.4.8-4.1,3-4.6,3.4-.8,2.7-1.9,3.3-1.6-.3-3.3,1.2-3.4,6.9-3.7,7.4,2.6,1.1,2.6,1.1l-7.9,4.2-6.8,1.4-5,.8s-19.2-2.3-20.4-2.8-.2-5.9-.2-5.9l-14.6-12.5-10.1,2.6s-5.4-4.1-6.8-4.1-5.3,1.1-7.1,6.9-4.1,19.1-10.4,21.4-9.8,2.1-10.2,3.5-6.3,2.6-7.4,3-9,8.6-9.6,10.8-5.9,8.3-8.9,30.7c-6.3,8.9-7.8,12.2-9.3,12.5s-5.9,2-6,.9-2.9.8-3.5,2-3,3.5-3,3.5l4.2,2.4s4.4,4.2,6.3,5.4c2,1.2,4.7.5,4.8-.1s1.2-1.5,1.2-1.5l-4.5-8.3,3.4-2.5,3.7,5.3,4-2.7-.4-3s7,.2,7.6.8.2,6.1.2,6.1l4.9-1.1s.8,18.1,5,18.8,13.8-.4,13.8-.4l1,5.7,5.1.2,2.5,4.7-1.9,3.3-8.1-.7-1.5,5.2s-9.7-.2-10.2.5,1,7.2,1,7.2l37.7,6.2,1.4,4.8-2.3,2.3-2.3-2.5h-3.9c0,.1,2.2,4.4,2.2,4.4l-.4,1.4-1.4-.8-2.1-4.2s-8.1,1.3-6.9,6.5,2.9,8.2,1.5,12.7-.2,2.5-.2,2.5l3.5-.3,2,5.7s-2,1.2-2.3,2.7-1.1,3.3-1.1,3.3c0,0-7.1,2.2-2.3,4.2h1.7c0,.1-3.9,2.5-3.9,2.5l-3.2,1.2s-1.4-2.2-.7-2.9,2.3-3.2,2.5-3.9.9-5.7.9-8-.3-9.9-.3-9.9l-1.3-4.2-2.2,1.7-1.4-6-3.8-1.4-7.9-.7.3,5.3,1.5,3.1v2.9l-3.4-3.2-.3-3.9v-5.1c-.1,0-16.3-1.5-16.3-1.5l-9.5.6v2.3c-.1,0-5.8-1.8-5.8-1.8,0,0-1.9,13.4-4.3,15.8s-8.3,7.7-8.3,7.7c0,0-6.4,4.4-5.3,0l.9-1.7-11.9.9,4.2,5,.4,3.3,4.8,1.1s-3.7,6.5-4,7-4.1,2.7-4.1,2.7l-.8,3.7,5.8,5.7,5.8,4.7,7.9-.4h6.4l-2.2,2.8,3.2,2.3,3.5-1.4-2.2,4s4.1,2.8,7.2.4,12.5-13.3,15.3-14.7,7.8-3.4,9.9-5.8,4.8-2.9,4.8-2.9l8.9,6.9-.6,4.4h4.8c0,.1,1.9,2,1.9,2l5.4.4,2.3,17.5-35.4,36.5,103,9.9,213.3-3.9s43.9-1.1,43.7-2.2-.8-105-.8-105l-2.8-25.1-11.9-11.5h0Z"
              />
              <path
                class="st37"
                d="M29.4,8.6c-.8,0-1.4.6-1.5,1.3-.2,1.8-.7,5-1.9,8-1.8,4.4,2.3,3.7,2.3,5.7s.2,7.6,3.5,6.7c.5-.1.8-.5,1-1,.6-2.4,2-4.5,4.7-3.9,2.3.5,9.4,4.6,12.4,6.5.7.4,1.6.2,2-.5.5-.9,1.3-1.9,2.5-1.7,2.1.3,6.7.5,7.7,3.8.1.4.5.7.9.9,2.7,1.1,3.1.4,6.9,1.9,4.1,1.6,9.1,3.4,12.2,5.8s4.2,6.5,4.4,6.9,1.8,6.8,3.5,6.8,7.6-.7,9.2-.1.4,2.3,1.4,3.4,2.4.8,2.6,1.4-2,4.6-.7,4.4,18.7-2.9,20.6-4,8.4-4,12-4.4,15.6-4.2,16.9-5.2,4.6-4.4,3.5-6.9-7.2-6.5-9.5-6.3-8.4,5.3-9.8,6.1-7.6,7.2-9.4,9.2-2.2,6.3-5.3,4.5-6.5-2.6-8.4-3-3.4-1.2-5.3-1.2-4.8-.4-5.8-3.1-1.5-5.4-3.8-5.2-3.4,3-6,3.4-6.5.3-5.3-1.8,4.4-1.2,3.5-4-1.6-4.6-1.4-5.7-2.2,1.1-2.9-1.4-2.7-5.3-.5-3.8c2.2,1.5,5.3,3.4,5.6,2s-2-2.7-2.2-3.8-1.5-4.2-.3-3.3,3.5,4,5.2,5.2c1.6,1.2,1.8-.8,3.9,0s3,.5,4.4,1.5,4.2,3.1,5.2.5,2.4-3.8,1.9-6-1.5-4-.7-5.3-7.2-2.9-9-3.8-4.5-2-5.4-2.5-4.6.7-5.8,1.8-2.2,4.6-3.5,2.5.4-3.3-1.8-4.1-2.7-2.2-1.5-2.7,2-1.5,2.2-2.3c0-.4.1-1.3.2-2.1,0-.9-.6-1.6-1.5-1.6l-53.2.4h0Z"
              />
              <path
                class="st37"
                d="M88.8,8.8s-1.8,3.7,4.5,5.2c6.3,1.5,8.3,2.6,11.2,2.4s4.5,1.2,5.7,1.1,1.8-3,3.9-2.4,2.6,3,4.8,4.1,5.8,1.9,8.6,1.6,4.6-.4,7.4-1.8,8.7-4.6,9.4-6.1.7-3.9.7-3.9h-56.1c0-.1,0-.1,0-.1Z"
              />
              <path
                class="st37"
                d="M588.2,9.8s1,14-2.8,17.7c2,3.2,3.9,4.5,5,5.8,1.1,1.3,4.3,1.1,4.8,3.9s2.2,3.8,3.2,4,1.8-.5,1.8-.5v-4l2.3-.4,1.5,2.4,3,1.2,5.5,1.1s4.2.8,4.3.5,1.2-3.9,1.2-3.9c0,0,.8-3.3,1.8-4s.6,0,4.3-1.2,4.8-2,7.2-2.3,3.4-.2,7.4-.6,5.7-1.3,7.2-2.4,3.9-2,3.9-2c0,0,4.4-1.8,5.7-2.7s5.1-3.7,5.1-3.7l3.8-2.3,1.5-6.1-6-10-11.2,5.7v4.2c-.1,0-.2,6.1-2,9.1s-3.2,4.4-4.4,5.4-4.5,2-5.2,1.2-2.4-1.5-3.8-1.2-3.3-.4-3-.7.5-1.8.1-3.3-2.9-1.8-3-2.6.4-1.5.8-2.7,1.1-1.5,0-3.2-2.3-1.6-2.6-2.7-6.2-3.4-6.2-3.4l-13.5-1.3-8.9,1.2-8.8,3.7h0Z"
              />
              <path
                class="st37"
                d="M508.9,328.3s-9.6,3.5-11.5,4.4-5.6,1-7.8,2.5-5.7,2.5-6.1,3.7-2-1-2-1c0,0-1.7-2-3-1s-3.2,4.2-5.7,4.7-7.8,1.7-9,.5-1.5-2-3.2-1.7-2.7-2.4-4.2-2.4c0,0-1.5.8-3.7.8s-3.2-.8-5.4-1.5-4-1-4.6-3-.3-5.4-2-6.4-6.2-2-4.2-4.7,3.5-2.4,3-3.9-2.9-5.6-2.9-5.6c0,0,2.9-13.5,3.7-15.7s1-4.9,1-4.9c0,0,2.4,4.9,4.4,5.6s4,2.2,4.2.5,0-3.5-.2-5.9-.8-6.4-1.5-7.3-3.2.2-2.2-2.2,1.7-5.9,2.2-7.1,4.9-3,7.3-3.9,4-1.4,6.1-2,2.9-2.2,5.6-1.2,4,2.2,5.2,5.2,2.9,6.4,6.1,7.6,2.2,1.4,8.3,2.4,9.5,1,11.1,2.4,3,4.2,4.2,7.6,2.2,8.6,3.7,10.6,1.5,4.4,2,6.2-1.2,2.9-2.7,3.4-6.6-1.7-6.9,1-1.5,4,1.2,4.6,7.3.3,8.8,1.4,1,4.9.7,6.2h0Z"
              />
              <path
                class="st37"
                d="M271.3,162c.4,0,.8.3.8.7.2,1.4.8,4.3,3.6,4.8,3.7.6,4.5-.4,6.5-1s3.1.8,4.5-.8c.4-.5.8-1,1.1-1.4.4-.6,1.3-.4,1.4.3.2,1.6.7,3.5,1.4,3.4,1.2-.2,6.7-3.3,7.6-3.5s1.2,1.4,2,2.4,3.7.4,5.3,0,5.3-.6,6.5-.6,1.9,1.3,2.3,1.8c.1.2.3.3.5.3l7.9,1.8c.5.1,1-.3.9-.8l-.3-3.1c0-.3.2-.6.5-.8l2.6-1.1c.2,0,.4-.3.5-.5.2-.8.8-2.8,2.4-3.7,2-1.2,5.9-1.2,6.7-1.8.7-.5,2.6-1.9,3.4-2.4.2-.1.4-.2.6-.1l1.8.5c.5.1.7.7.5,1.1-1.3,2.4-4.9,9.1-5.3,9.6-.4.6-3.7,4.9-3.5,5.5s2,6.3.2,9.6-.4,6.9-3.1,7.6-8.6.8-9.4.8-2,0-3-.1c-.5,0-.9.4-.8.9.3,2.2,1.4,7.9,4.2,9.9.3.2.4.7.2,1-2.4,3.4-6.2,7.4-7.2,8.5-.2.2-.4.3-.7.2l-5.2-1.1c0,0-.2,0-.2-.1l-6.7-4.3c-.3-.2-.7-.1-1,.1-1.1,1.3-4.1,4.9-5.3,7.5-1.4,3.3-2,4.3-4.1,5.1s-7.1,3.1-8.2,3.1-2.5-.6-4.5-2.9-4.5-3.9-6.1-5.1-3.7-2.4-5.1-5.5-4.1-7.1-3.1-8.6.2-2.2-1.2-1.6-3.3,1.8-4.7,2.9-3.1,1.8-5.7.6-5.1-1-5.7-2.4-.4-2.2.4-3.5,0-2.7,1.2-4.5,2.7-1.4,3.7-2.4,2.2-2.2,2.9-3.7-.6-1.4-2.9-2.7-3.7-1.4-2.7-3.5,2.2-5.5,2.7-6.7,1.6-3.5,1.6-3.5c0,0,1-2.7,3.3-2s3.5,1.4,5.5,1.2,3.7,2.9,4.5.2-1.4-3.3.4-4.3c1.2-.7,2.7-.9,3.5-1h0Z"
              />
              <path
                class="st37"
                d="M170.9,6.2c-.9.2-1.3,1.2-1,2,.7,2,2.4,5.3,5.3,5.9,2.8.6,3,2,2.9,3,0,.5-.4,1-.9,1.2-1,.4-3,1.4-3.1,3.1-.1,2.2.4,3.7,1.6,4.6s2.1,1,1.9,3.3c-.1,1.5-.3,3.1-.4,4,0,.5-.4,1-.8,1.2-1,.5-2.8,1.4-3.6.9-1.2-.6-3.4-2.1-4.5-1.9s-5.8.9-6.4,1.5-1.6,1.2-1.6,2.8-1.6,6-1.2,6.4,2.2-.2,4-.3c.6,0,1.2,0,1.8,0,.9,0,1.6.7,1.5,1.6,0,1.3-.2,3-.7,3.4-.9.8-2.2,1.3-4,.6s-5.2-2.5-4.8-.9,2.7,2.7,4.6,5.5,2.5,8.4,4.3,9.6,5.8,4.5,7.6,5.2,9.1,4.2,9.9,7,.9,4.6.3,6.4-3.9,12.1-4.6,15-.3,6.1-.3,6.7,1.4,7.8.3,10.5.3,8.2,1.1,11.1,1.8,7.2,2.8,8.5,7.9,5.2,9.4,6,6.3,2.1,7.2,1.2,3.3-1.6,2.2-3.6-4.8-2.5-6.4-3.7-3.3-2.5-3.9-3.6-3-3.1-1.8-3.3,1.9-.4,2.4-1.2-.3-3.3.9-3.1c.7,0,2.6.9,4.1,1.5.9.4,1.2,1.5.6,2.3-.4.5-.7,1.1-.6,1.6.3,1.2,1.5,4.2,2.2,5.1s2.5-.6,3.1-1.9c.1-.3.3-.7.5-1,.5-1,2-1.1,2.6-.2.5.7,1,1.4,1.5,1.7,1.2.8,3-.8,4.2-1.5s1.4-1.6,2.7-1.2c.9.3,2.4.4,3.4.4.5,0,1-.2,1.3-.6h0c.6-.8.3-1.9-.6-2.3-1.9-.8-4.6-2.1-5.5-3-.8-.9-2-2.6-2.8-3.8-.5-.7-.3-1.7.4-2.2,1.8-1.2,5-3.3,5.4-3.9.6-.9,1.8-8.5,3.4-9.9s3.4-2.7,3.6-3.7-1.6-3-.6-3.7,1.5-1.3,1.9-1.2c.4.1,3.1.9,4.1,1.2.3,0,.5.2.7.4l1.2,1.3c.5.6,1.4.6,2,.2l.7-.5c.4-.3.7-.8.6-1.4l-.3-3.2c0-.4-.3-.8-.6-1.1l-1.8-1.3c-.3-.2-.7-.3-1.1-.3-2.2.3-9.5,1.3-10.2,2-.8.9-1.8,2.5-2.7,2.1s-3.6-.9-2.7-.2c.4.3.7,1.2.8,2,.2,1.1-.7,2.1-1.8,1.8l-1.2-.3c-.4,0-.8-.3-1-.7l-1.2-1.9c-.2-.3-.5-.6-.8-.7-.7-.2-1.9-.6-2.8-.7-1.2-.2-3.1-.8-4.6-.8s-6.9.9-6.1.2,3.1-1.5,3.4-2.2c.3-.7,1.2-4.4,1.5-5.2,0,0,0-.2,0-.3,0-.7.3-4,1.5-4.5,1.4-.6,4.3-.4,5.2.2s2.4,3.3,3,4.9,1.1,4.2,2.2,4.5,2.4.6,2.8-.2.9-2.5,1.8-2.1c.3.1.7.3,1.1.5,1,.4,2.1-.2,2.2-1.3s0-2.2-.3-3c-.8-1.7-1.2-3.6-.6-4.6s.1-4.3,1.8-3.1,2.8,2.2,3.1,1.7.3-2.8,2.8-2.2,5.7,0,6.3,1.5,1.5,1.9,2.2,1.5,1.6-.2,1.6-1.7.4-4.3-.6-4.9-2.2-1.2-1.9-2.4.1-4,.9-2.8,2.8,2.5,3.1,3.3.1,2.2,1.4,2.5.8.2,1.2.2c1,.1,1.9-.8,1.7-1.8-.1-.4,0-.9.2-1.3.9-1.2.3-2.1,2.4-2.1s3,0,4.3.9,2.2,1.5,3,.8,2.2-3,2.5-3.9,1.3-3.3.3-4.2-.3-2.8-1.6-3.3-4.9-3.6-6-3.1-2.5,1.9-3.7,2.8-5.4,2.8-5.8,1-.4-4.3-1.8-4.3-4.6-.3-5.7-.5-2.2-.6-3.9.5-4.2,1.8-5.5,1.5-3.3,1.2-4.5.5-2.1-2.1-2.2-2.8-1.8-.9,1.5-.9,5.8.8,6.7,0,1.1-.8,1.8-1.8,1.6-2.8,2.5-1.9.1,2.7,1.6,2.7,2.4.3,3.6-.3.4-1.8,2.7-.8,2.8,2.5,4.6,3.4,3.7,1.8,4,.9-3.1-1.3-3.3-3.4.1-3,1.6-4,3.9-1.2,5.2-1.5c.8-.2.4-1.9,0-3.1-.3-.8.1-1.6.9-1.9,1.4-.6,3.4-1.4,4.3-2,1.4-.9,6.4-2.7,7-3s3.6-2.1,4.5-2.8,3.3-2.7,4.3-3.6,3-2.1,3.7-3-1.5-8.5-1.5-9.1-3.3-6.5-4.1-8c-.1-.2-.3-.4-.6-.6l-6.6-3.8c-.2,0-.3-.2-.5-.2L228,0C227.9,0,227.8,0,227.8,0l-29.2.6-8.9.3c-.1,0-.2,0-.4,0l-18.4,5.2h0Z"
              />
              <path
                class="st37"
                d="M667.9,50.2l-5.3,1.4,2.4,4.6-3.2.4.3-2.1s-4.9.8-5.6.8-3.5-1.8-3.5-1.8l-2.1.7s3,4.4,3.7,4.6,3.1,1.4,3.5,1.7,1.1,3.9,1.1,4.5-2.8,1.7-2.8,1.7l2,2.2.8,2.8-2.2,4.1-.8,1.1s-4.5-2.7-5.1-3.4-4.8-.8-5.8-2.1-6.5-6-6.5-6l-7.6-4.4s-7.6-.8-7.9-.4-15.3,20.5-15.3,20.5l1.8,3.2s2.2-1.6,3.1-2.8,3.2-3.2,3.7-3.4,3.8-.3,4.6.4,3.1,1.3,3.7,1.3,1.8,2.4,1.8,2.4l-3.2,1.7-1.1,2.8,3.4,1.1.4,4.5v12.2c.1,0-7.9,7.3-7.9,7.3l-13.1,1.3s4.4,4.8,4.8,8.2.8,7.3.8,7.3l1.3,5.9,2,9.8-1.1,3.1-8.7-1.7,1.7,3.4v4.5c-.1,0-5.9.3-5.9.3v4.1c-.1,0,.7,5.1,1.8,5.1s1.4,0,2.8-.1,8-.7,8-.7l3-.3,4.2,5.1-2.2,2.1-12.9,6.2,8.8,14.2,11.1-10.7,18.3-10.7,2.2.8s.4-1.8,1.1-2.7,1-1.3,1.5-1,3.2,1.1,2.7.6-2.8-2.2-2.8-2.2c0,0-1.7-2.2-.4-3.2s3.7-3.5,3.7-3.5l2.8-2.4,3-2.2,1.3-5.6s3.7-5.8,3.9-6.5.7-5.5,1-5.9.4-4.4.4-4.4c0,0-4.9-1-4.9-1.7s-.6-3.2.3-3.8,3.5-1.4,4.5-2,5.3-3.2,5.3-3.2l3.4-3.9,1.1-4.9,1.4-20.4,3.5-19.7-2.7-9-3.4-11.4h-3.8c0,.1,0,.1,0,.1Z"
              />
              <path
                class="st37"
                d="M842.9,7.9s-.5,4.6-.2,5.3,1.1,2.4,1.1,2.9.7,2.8.9,3.4,1.1,1.5,1.1,1.5c0,0,2-.6,3.7-.3s5,.2,5.6,0,7.8-.6,7.8-.6c0,0,4.8-.1,5-.2s5.3,1.4,6.9,2,4.2-1.9,4.2-1.9l1.9-3.9.8-4.7.4-4.7-4.7-1-34.5.6v1.6c0,0,0,0,0,0Z"
              />
              <path
                class="st37"
                d="M475.8,441.9s2.5-2.1,5.2-3.2,6.7-1.8,6.7-1.8c0,0,6.4.7,7-.7s0-5.2,0-5.2l-.8-9.1s-2.9-6-2.8-7.2,0-4.2-1.4-5.2-3.6-1.7-3.9-2.8,4.5-7.2,4.5-7.2l.4-1.7-6.7-5.7-9.2,8.8h-4.3c0-.1-4.3-3.2-4.3-3.2l-1.8-.3-3.2,3.2s-2.8,1.4-3.4,2.8-1.1,7.1-1.4,7.7-2.2,3.1-2.6,3.2-15.6-.7-15.6-.7l-14.8,25v4.3c-.1,0,45.1,4.2,45.1,4.2l7.5-5.2h0Z"
              />
              <polygon
                class="st37"
                points="343 351.4 348.8 360.3 338.7 366 335.4 362 327.2 369 319.8 367.3 324.6 358 331.6 352.8 337.8 351.2 343 351.4"
              />
              <path
                class="st37"
                d="M386.7,377s-7.6,3.8-9.1,4.6-4.6,5.2-5.3,6.4-3.3,4.8-4.1,4.9-2.5,9.8-2.5,9.8c0,0-8.5,3.5-12.7-.7s-4.8-6.6-4.8-8.1-1.6-4.6.1-5.7,4.2-2.2,5.3-3,1.2-6.4,1.5-7.1.1-6.6-1.2-6.8-9-.7-12.8,4.9-2.5,8.2-2.5,8.2v4.1c.1,0,3.6,4,3.7,7s-.5,9.4-4.4,12.8c-4.4-2.3-10.4-5.9-12.4-9.8s-3.1-5.3-3.1-5.3l-3,.5,1.1,6.8,19.5,16.7,12,2.7s17.5-10,18.9-11.3,3.1-3.5,5.3-4.4,6.1-1.5,6.1-1.5l4.5-1.9s.7-18.5,2-20,4-6,4-6l-6.1,2h0Z"
              />
            </g>
            <g id="River">
              <path
                class="st33"
                d="M417.8,447.1l-5-.3c.5-8.9,11-19.2,11.4-19.7,12.3-12.3,9.3-20.5,9.1-20.8v-.4c-1.8-6.7-4.9-12.9-9.3-18-3.9-4.6-11.8-12.4-20.4-12.7-4.1-.1-7.9,1.2-10.6,3.8-2.3,2.3-3.5,5.2-3.5,8.6,0,7.7-.1,15.7-2.3,22.7-.8,2.4-2,4.5-3.8,6.5-13.8,15.5-37,6-45.8,2.4-20.4-8.4-23.4-24.5-23.8-37.7-.4-12.7,8-31.8,24.2-33.3,8.1-.8,16.1-5.2,21.4-12,4.8-6.2,6.8-13.5,5.6-20.6-.9-5.5-4.2-9.9-7.8-14.6-.4-.6-.9-1.1-1.3-1.7-9.5-12.8-2.1-28.7,9.4-38.8,4.5-4,10.1-6,14.8-5.4,3.7.5,6.8,2.5,9,5.8,1.8,2.7,2.8,5.7,3.7,8.6.8,2.4,1.5,4.6,2.6,6.6,1.4,2.5,2.8,4.2,4.3,5.4,5,4,11.8,5.4,17.8,3.6,5.1-1.5,8.8-5.2,10.4-10.4,2.2-7.1,1.9-14.3,1.6-21.9-.1-2.6-.2-5.3-.2-8v-1.8c0-9.4,0-15.6-11.5-22.3-6.9-4-13.2-5.3-17.8-3.8-2.7.9-4.6,2.8-5.7,5.5-3.5,8.6-12,18.4-12.3,18.8h-.1c-15,15.2-35.5,16.7-36.4,16.7h-.1c-.3,0-.6,0-.9,0-25.7,0-28.3-16.9-28.6-20.4-.9-14.6-1.2-18.6-5.5-23.9-2.2-2.8-5.8-4.7-9.5-6.8-5.8-3.2-11.7-6.6-13.8-13.3-3.4-11.2.8-21,10.8-25,5.5-2.2,12.8-1.1,19.1-.1,3.3.5,6.4,1,8.3.8,5-.6,14.6-5.3,14.8-12.3.7-19.8-13.9-24.4-15.6-24.9-2-.6-5.6-.7-9.5-.8-5.7-.2-12.2-.4-17.2-2.1-8.3-2.7-16.8-13.8-25-24.5l-2-2.6c-8-10.4-10.2-17-8.3-25,.7-3.1,2.7-6,5-9.3,2.9-4.3,6.2-9.1,8.1-16,2.6-9.7-6.6-34.3-10.4-43l4.6-2c.6,1.3,14.2,32.9,10.6,46.2-2,7.8-5.8,13.2-8.8,17.6-2,2.9-3.7,5.4-4.2,7.6-1.3,5.5-.5,10.5,7.4,20.8l2,2.6c7.4,9.6,15.7,20.6,22.5,22.8,4.4,1.4,10.5,1.6,15.8,1.8,4.3.2,8.1.3,10.6,1,2,.6,20,6.3,19.2,29.9-.4,10.4-13,16.4-19.3,17.1-2.5.3-5.8-.2-9.6-.8-5.7-.9-12.2-1.9-16.5-.2-8.9,3.6-9.9,12.1-7.8,18.9,1.5,4.8,6.3,7.6,11.5,10.4,4,2.2,8.1,4.6,10.9,8.1,5.4,6.7,5.7,12.1,6.6,26.6,1.2,15.1,20.3,15.8,24.3,15.7,1.1,0,19.7-1.8,33-15.1.7-.8,8.4-9.7,11.4-17.3,1.6-4.1,4.6-7,8.7-8.4,6-2.1,13.8-.6,21.9,4.2,14,8.1,14,16.7,14,26.7v1.7c0,2.6.1,5.3.2,7.8.3,7.7.6,15.6-1.8,23.6-2.1,6.8-7,11.6-13.7,13.7-7.5,2.3-16.1.5-22.4-4.5-2-1.7-3.8-3.8-5.5-6.8-1.4-2.4-2.2-5-3-7.5-.9-2.7-1.7-5.3-3.1-7.4-1.4-2.1-3.3-3.3-5.5-3.6-3.3-.4-7.4,1.2-10.9,4.2-11.8,10.3-15.2,23.2-8.7,32,.4.5.8,1.1,1.2,1.6,3.7,5,7.6,10.1,8.7,16.8,1.4,8.5-.9,17.1-6.6,24.4-6.1,7.9-15.4,13.1-24.9,13.9-13.1,1.2-19.9,17.4-19.6,28.2.4,12.4,3.1,26,20.7,33.2,13.4,5.5,30,10.3,40.2-1.1,1.3-1.5,2.2-3,2.7-4.7,2-6.3,2.2-13.9,2.1-21.1,0-4.7,1.7-9,5-12.2,3.6-3.5,8.8-5.5,14.2-5.2,10.5.4,19.6,9.2,24,14.5,4.9,5.7,8.4,12.6,10.2,20,.6,1.8,3.5,12.2-10.3,26.1-2.7,2.6-9.6,10.6-10,16.4h0Z"
              />
              <path
                class="st33"
                d="M788.7,267.9c-9-18.2-34.5-42.1-34.5-42.1,0,0-9.7-10.2-16.9-18.1s-11.7-19.2-25.6-39.8c-13.9-20.6-18.9-33.8-11.8-50.2,10.8-27.6,3.7-38.7-3.4-46-7.1-7.4-22-30.1-23.9-37.5-1.8-7.4,4.4-27.3,4.4-27.3,0,0,.3-2.8-13.9-.8-4.9,17.4-.2,26.1,4.5,40.3,4.1,12.4,3.5,26.6,3.9,39.5.2,8.2.3,16,2.1,24.1,1.8,8.1,4.4,16,6.7,24,3.8,13.3,7.7,26.9,13.4,39.6,2.9,6.5,6.1,13,9.6,19.2,2.6,4.6,4.8,10.7,8.7,14.3,2.3,2.1,5.3,3.3,7.8,5.2,5.1,3.7,7.4,9.4,10.7,14.6,3.5,5.5,7.4,10.9,12,15.5,7.9,8,16.1,14.9,22.3,24.3,4.3,6.5,10.8,16.7,8.9,24.9-2.2,9.8-12.3,16.6-31.9,32.9-19.6,16.4-15.3,31.3-12.1,35.6,9.8,13.7,10.6,23.9,9,32.7-1.6,8.8-10.4-2.7-27.8-16.1-20.2-13.7-40.1-8.6-49.7-.8s-22.1,31.3-26.2,36.4c-6.1,5.1-4.9-3.1,2-17.8,7.2-17.4-2-32.5-14.9-36.2-12.9-3.7-36.4,8-46.8,26.2-10.4,18.2-12.1,25.6-24.1,33.1-27.4,17-72.8,23.7-72.8,23.7l59.1,3.2c7.3-2.7,14.3-6.5,21.1-10.3,3.8-2.1,7.5-4.3,11-6.9,4.1-3,6.8-7.1,10.7-10.2,4.7-3.7,11.7-4.2,16.5-.4,5.9,4.7,12.2,24.6,12.2,24.6,0,0,1.8,4.8,12,3.2-.5-5.4-4.8-15.9-8.2-22.6,4.5,1.3,7.8.1,9.4-.6,3.3,4.1,8.3,5.9,13.7,7,.5.1,1,.2,1.4.6.3.3.5.6.7,1,2.2,4.6,4.3,8.8,7.7,12.7l8.5-1c-1.3-.6-2.6-1.3-3.8-2.2-10.3-7.4-.3-23.6,6.6-29.7,9-7.9,20.5-12,31.2-17.1,12.9-6.2,22-6,29.6,10.5,7.5,16.5,19.9,16.2,28.7,14.4s28.3-9.4,26.6-32-11.8-30.1-19.8-32.5c-8-2.4-13.5-10.4,3.3-19.2s27.6-23.3,30.5-29.3,10.4-18.5,1.4-36.7h0ZM687,66.1c1.7,1.2,6.7,5.1,9.3,12.8,2.5,7.7,3.5,15.2,3.8,17.6,0,.2-.3.4-.5.2-2-2.2-8.8-10-9.7-15.6-.9-5.6-2.7-12.5-3.3-14.6,0-.2.2-.4.4-.3h0ZM696.4,105.8c-.3,1.4-2,8.4-5.9,14-.3.4-1,.3-1.2-.1-1.5-3.5-5.8-15-5.2-29.6,0-.6.8-.9,1.2-.4,2.1,2.6,6.9,8.8,11,15.7,0,.2.1.3,0,.5h0ZM621.2,397c-2.4,6.2-3.7,13.6-1.3,20-5.8.4-9.5-1.3-18.2-7.9-6.5-5-13.3-6.6-17.4-7.2,3.6-9,11-17.1,17.6-23.7,8.5-8.5,17.9-10.2,21-7.5s6.7,4.4-1.7,26.3h0Z"
              />
              <path
                class="st33"
                d="M754.9,236.8c.9-5.6,2.5-15.3,8.8-17.3,5.2-1.3,10.2,1.1,15.3,1.4,3.4.4,6.5-.8,8.2-4,.6-1.1,1.5-2.7,1-3.7h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0-.1,0-2.3,0-4.6,1.7-6.7,2.9-4.6,2.2-10.2.2-13.1-3.8-1.8-2.4-4-3.8-7-3.8-5.5.2-10.7-3.2-12.7-8.4-1-2.5-1.4-5.1-1.5-7.7,0-3.8,0-7.7,1-11.4,1.3-5.4,5.2-7.1,9.9-4.1,3.2,2.1,5.7,4.4,9.5,4.2,1.6,0,4.1-1.5,3.7-3.2,0-.2-.4-.5-.9-.8-2.7-1.7-5.9-1.7-8.7-3.2-1.9-1-1.9-3.1-.7-4.6,1.8-2.1,4.1-3.4,6.6-4.4,2.9-1.2,7.2-2.8,7.8-6,0-2.2-2.5-1.6-4.2-.7-4.1,1.9-9.5,6.3-14.1,3-2-1.6-3.6-3.3-5.3-5.1-2.1-2.1-5.4-4.4-4.7-8,1.3-4.5,7.8-1,10.7-.4,2.7.4,4.8-3,5.7-4.8.5-1.8,1.1-3.5,1.6-5.3.7-2.6,1.7-5.2.9-7.8-.7-1.7-2-3.2-2.5-5-.8-3.2.3-7.4,4.3-6.6,3.5.6,7,3,10.5,1.6,1.4-.6,3.1-1.8,3.2-3.4-.2-2.4-3.7-2.3-4.7-4.4-.7-1.7.9-3.4,2.2-3.9,3.6-1.7,7.6-1.3,11.2-1.5,1.9,0,3.3-1,5-1.9.4-.2,1.1-.3,1.5-.3,2.1-.3,3.7-2.4,4.5-4.2.7-3.4,2-5.3,5.8-5.5h.2s0,0,.1-.2c.1-.8-.2-1.8-.5-2.6-.1-.8-.2-1.5,0-2.3.2-1.5,1.9-2.7,3.3-2,.8.4,1.1,1.8,1.6,2,.6.2,1-.2,1.3-.7.4-.5.9-1.4,1.5-1.7,1.6-.7,3.1.2,4.4,1h0c.4,0,.8.1,1.1,0,.5-.4.2-1.6,0-2.2-.4-1.5-2.3-3.2-.7-4.7,1-.7,2.2-.8,3.1-1.4,1.1-.5,1.8-1.6,3.1-1.6,1.1,0,2.5.5,3.3,1,1,.5,2.2-.4,3.3-.5,1.3,0,1.2,1.9,1.3,2.6,1.6.3,3.5,0,4.7-1.2,1-1.2,1.4-2.8,2.3-4.1.5-.7,1.4-1.1,2.2-1.1h-.1c1.2-.7.4-2.1-.2-3h0c0-.5.4-.8.6-.9.8-.6,2.2-1,2.9-1.6,0,0,0,0,0,0v-.2c.3-.7.5-1.4,1.1-1.9.5-.4,1.3-.2,1.8.1,1,.4,2.3.9,2.8,2,.4.8.4,1.7.5,2.5,0,.1,0,.3-.1.5-.2.1-.3.1-.4.2-1.2.5.9,1.7,1.1,2.3.3.6.2,1.2.2,1.7,0,.6-.4,1.1-.4,1.6.9,1.3,2.7,2,4.2,1.7,1.6-.4,3.3-1.5,5.1-1.5.5,0,.9.4,1,.9v.5c0,.3,0,.8.3.9.5.3,1.4,0,1.5.7.1.8-.7,2-.1,2.6.9.6,2.2.3,3.1-.3h0c0,0,0,0,0,0,.6,1.8.6,4.4.6,6.1,1.8,0,3.6,1,5.4.3,2.2-1.9,5-3.1,7.2-5.1.7-.7,1.4-1.4,1.8-2.3-1.2,2.7-4.2,4.1-6.5,5.8-.8.5-1.7,1.1-2.4,1.7-.4.2-.9.3-1.4.2-1.4,0-2.7-.6-4.1-.5,0-1-.1-2.1-.2-3.1,0-1-.2-2.1-.5-3h.1c-.9.6-2.3,1-3.3.3-.6-.6,0-1.5,0-2.2,0-.3.1-.8-.2-.8-.5,0-1.4,0-1.5-.7,0-.7,0-1.7-.8-1.8-1.7,0-3.3,1.1-5,1.5-1.7.3-3.7-.4-4.6-1.9,0-.7.4-1.1.4-1.7,0-.5,0-1.1-.2-1.6-.4-.7-1.3-1.1-1.5-2,0-.2,0-.4.2-.5.1-.1.3-.2.4-.3.1,0,.3,0,.3-.1,0,0,0-.1,0-.3,0-.3,0-.6,0-.8,0-1.1-.5-2.2-1.5-2.7-.7-.4-1.6-.7-2.3-.9-1-.1-1.3,1.1-1.6,1.9-.1.5-.6.7-1,.9l-1.5.8c-.3.2-1,.6-1.1.9h0c.5.7,1.2,1.7.8,2.7-.2.4-.5.6-.8.8h0c-1.7,0-2.3,1.7-3,3-.6,1.5-1.7,3-3.4,3.4-.9.3-1.9.3-2.8.2,0,0-.2,0-.4,0-.2-.1-.2-.4-.3-.5,0-.7,0-1.8-.7-2-1.1.2-2.3,1.1-3.6.5-.9-.6-2-.9-3.1-.9-.9,0-1.7,1.1-2.8,1.5-.9.6-2.1.8-3,1.4-.7.6-.3,1.8.3,2.7.2.4.4.9.6,1.3.8,1.8.5,3.8-1.9,3.1-1.1-.7-2.5-1.5-3.7-.9-.5.2-.8.9-1.2,1.5-.4.7-1.4,1.3-2.2.9-.8-.3-1-1.2-1.4-1.8-.8-.8-2.3-.1-2.5,1.2-.3,1.4.3,2.4.5,3.8,0,.6.2,1.2-.4,1.7-.2.2-.5.3-.8.2h.2c-3.5.2-4.3,1.8-5,5-.7,1.9-2,3.4-3.8,4.4-.8.5-1.9.3-2.7.7-1.5.9-3.4,2-5.3,2-3.7.2-7.5-.2-10.8,1.5-1.1.5-2.1,1.4-1.7,2.5,1,1.4,3.3,1.7,4.3,3.3,1.7,2.6-1.2,5.2-3.4,6.1-1.9.8-4,.5-5.9,0-2.5-.5-5.2-2.5-7.5-1.2-1.1,1-1.1,3.2-.7,4.6.5,1.8,1.8,3.1,2.5,4.9,1.1,2.8,0,5.9-.8,8.6-.5,1.8-1.1,3.6-1.6,5.4-.5,1.1-1.2,2.2-2,3.2-1,1.2-2.5,2.4-4.2,2.6-1,.1-2-.3-2.9-.6-1.7-.4-6.5-2.4-7-.2-.4,2.9,2.6,4.6,4.4,6.5,1.6,1.7,3.3,3.5,5.1,4.8,1.6,1.2,3.9.9,6,0,3.4-1.2,6.2-4.3,10.2-4.2,1.7,0,2.9,1.8,2.8,3.5-.4,2.9-3,4.8-5.4,6-3.1,1.6-7,2.4-9.2,5.3-.3.4-.5.8-.4,1,0,0,0,.1,0,.1,0,0,0,.1,0,.2.2.1.2.3.5.4,2.3,1.2,6.1,1.5,8.7,3.2.6.4,1.3.8,1.7,1.8,1.1,3.3-2.6,6-5.5,6-2.1,0-4.1-.4-5.9-1.4-2.6-1.3-4.9-3.8-7.7-4.2-3.5,0-3.8,4.8-4.2,7.5-.4,4.6-.6,9.8,1.2,14.1,1.3,3.1,3.9,5.7,7.2,6.5,2.4.5,5,.1,7.5,1.1,1.4.5,2.5,1.4,3.5,2.4.9.9,1.6,1.9,2.5,2.8,2.1,2.4,6.5,3.1,8.7,1.9,2.4-1.3,7.6-5,10.2-2.2,1.7,2.3.3,4.8-.7,6.8-1.5,2.7-4.4,5-7.7,5.3-2.3.2-4.7,0-6.9-.4-3.5-.5-7-1.8-10.4-.9-4.7,1.6-6,10.5-6.7,14.9l-3-.3h0Z"
              />
              <path
                class="st33"
                d="M663.7,375.5s-8.9-3.8-12.2-8.8c-2.6-3.9-1.9-9.3,1.2-12.8,7.4-8.2,16.1,1.3,22,6.1,1.5,1.2,4.7,4,6.3,1.6,1.8-2.6,1.8-6.2,2.1-9.2.4-4.4,5.4-12.3,10.3-15.2,2.5-1.5,4.3-3.7,4.1-6.7-.2-3.3-2.5-5.7-3.9-8.5-.9-1.9-1.7-3.9-2.1-5.9-.3-1.6-.7-3.5-.3-5.2.7-3,1.1-6.2.7-9.3-.6-4.5-4.8-6.6-8.4-8.6-2.6-1.5-5.6-3.1-8.7-3.6-2.3-.4-5.5-.9-7.3-2.6-1.6-1.5-2.4-4-2-6.1.5-3.3,3.3-5.9,5.9-7.7,2.8-2,5.5-4.4,7.6-7.1.7-1,1.7-1.8,1.7-3.1s-.8-2.2-2.1-2.3c-3.2-.2-5.6,2-8.2,3.5-1.4.8-2.4,1.7-4,1.8-5.2.4-9.4-2.6-11.2-7.4-2.3-6,1.4-21.4,3.6-30s9.3-9.4,13.6-7,11.6,2.3,13.7,1.5,5.2-5.7,7.5-6.9,5.2-2.2,6.9-5.9c5.2-9,.9-22.2.9-22.2l10.7,6.5.5,11.6c-2,3.1-4.1,6.8-6.9,9.2-3.2,2.8-7.6,2.8-11.3,4.5-3.2,1.5-5.3,4.4-7.4,7.1-1.8,2.3-5.1,2.8-7.8,2.2-2.8-.6-5.1-2.4-7.5-3.9-3.7-2.3-6-1.3-7.5.7-.8,1.1-1.1,2.7-1.4,4-.5,1.9-.8,3.9-1.2,5.8-.8,4.5-2.4,9-2.7,13.6-.2,2-.3,4.3,0,6.3.7,3.8,4,6,7.8,5.7,4.3-.4,6.7-4.9,10.9-5.8,3.5-.8,6.3.3,7.2,4.2.9,4-2.5,7.8-4.5,11.2s-7.2,7.2-9.6,8.8c-1.9,1.3-3.3,4.1,0,4.8,2.3.5,4.6.6,7,1.3,4.9,1.5,9.4,4.3,13.5,7.2,2.6,1.8,4.5,4.5,5.1,7.6.7,3.6-.3,7.6-.2,11.3,0,1.7,0,3.5.5,5.1.5,1.5,1.6,2.8,2.5,4,.7,1,1.3,2.1,1.7,3.3,1.1,2.8,1.4,5.9.8,8.9-1.2,6.3-7.6,8.4-11.1,13.4s-2.1,12-3.7,15.7-6,5.1-8.6,4.7c-1.5-.2-3-1.4-4.3-2.2-1.8-1.2-3.5-2.5-5.2-3.8-.2-.2-.5-.4-.7-.6-2.1-1.7-4.3-3.5-6.8-4.4-1.8-.6-4.3-.9-5.9.3-2.4,1.9-2.4,6.3-1.3,8.8,1.2,2.7,4.2,4.1,6.6,5.5,2,1.1,4,2.1,6,3l-3,1.9h0Z"
              />
              <path
                class="st33"
                d="M624.3,359.7c3.7-3.1,7.8-6.4,10.2-10.6.5-1.4.3-3.1.3-4.7-.1-3.4.2-7.3,2.5-10.1,2.2-2.6,4.8-4.8,6.9-7.5,2.9-3.1,5.3-6.7,8.8-9.3,1.4-.7,3.4-.6,4.3-2.1.8-1.4.8-3.1.9-4.7,0-1.4.4-3.1,2.2-3.1,2,0,4.3.9,6-.3,2.2-1.9,1.8-5.3,5.8-3.5.2.1.6,0,.9,0,4.6-2.5,9.7-5.6,12.2-10.5-1.8,4.1-5.6,6.7-9.2,9.1-1.1.7-2.1,1.6-3.4,1.8-.9,0-2-.8-3-.4-.7.3-1.1,1.1-1.5,1.8-1.2,3.1-3.8,3.2-6.7,2.7-1.2-.1-2.5-.1-2.6,1.3-.4,3.7.2,7.6-4.5,8.4-.3,0-.8.2-1.1.4-3.2,2.6-5.6,6.2-8.4,9.3-1.6,2-3.3,3.9-5.1,5.7-1.8,1.7-3,3.8-3.4,6.2-.9,6.4,1.8,9.1-3.6,14.7-2.3,2.6-4.8,4.9-7.4,7.1l-1.3-1.6h0Z"
              />
              <path
                class="st33"
                d="M432,278.2l-.7-1.9c6.8-2.5,9.3-9.2,10-12,.1-.5.2-1.1.2-1.6,0-2.7-.2-12.5.2-25.6.4-5-.6-8.7-3.1-11.1-3.8-3.7-9.7-3.2-9.8-3.2h-3.2c0,.1,0-1.9,0-1.9h3.1c.2-.1,6.9-.7,11.3,3.6,2.9,2.9,4.1,7.1,3.7,12.6-.4,13-.3,22.8-.2,25.5,0,.7,0,1.5-.3,2.2-.8,3.1-3.6,10.6-11.3,13.4h0Z"
              />
              <path
                class="st33"
                d="M573.5,390.7c-2.9-1-2.7-4-1.9-6.4.1-2.9-3-5.1-5.5-6.1-2.1-.7-4.2.4-6.4-.5-3.6-1.1-1.4-6.6-5-7.5-2-.4-4.2.2-6.2.3-4.4.2-8.7.2-13.1.1-4-2-8-4-11.9-6.3-1.5-1-3-1.7-4.2-3.1-1.5-2.4,3.7-5.4,5.2-6.7l1.3-1c.6-.5,1.3-.8,1.3-1.5.5-5.2-.2-10.5-.3-15.7,0-1,.2-2.2-.2-3-.4-.7-1.6-.5-2.6-.3h.2c-2.3,2.1-6.2,2.9-8.2,0-1.8-2.4-2.7-5.4-2.5-8.4,0-2.2.6-4.3.8-6.5,0-3.6-1-7.1-2.1-10.4,0-.5,0-7.2,0-7.6,0-.8-.6-1.4-1.1-1.9-1.9-2-4.4-3.6-5.5-6.3l-.3-.8c-.1-.2-.2-.5-.4-.7-1.9-3-4.5-5.8-1.3-9.1,3.8-4,8-7.7,12.8-10.6,1.9-1.1,4.2-2.2,6.4-1.3,4.1,1.1,8.8,2.5,12.9.8,4-1.9,7.6-4.5,10.9-7.4.8-.7,1.5-1.6,2.4-2.3,1.8-1.4,4-2,6.1-2.6,1.6-.4,3.2-.9,4.2-2.4,1.9-2.4,5-2,7.7-1.2,1.1.2,2.2.4,3.3.4-1.1,0-2.2-.2-3.3-.4-4.2-1-5.9-1-8.8,2.5-1.9,1.1-4.2,1.4-6.2,2.2-2.2.7-3.7,2.3-5.3,3.9-3.3,3-6.9,5.6-10.9,7.5-2.1.9-4.4.9-6.6.7-2.2-.2-4.4-.8-6.5-1.4-1.1-.4-2.1-.5-3.2,0-5.1,2-9.3,6-13.3,9.6-2.4,2.3-5.1,4.7-2.7,8.1.7,1.1,1.6,2.3,2.2,3.5.5,1.9,1.9,3.3,3.3,4.6,1.5,1.5,4,3,3.7,5.5v6.6c.9,2.2,1.8,5.6,2.2,8.4.4,2.9-.7,5.8-.7,8.7,0,3.3,1,7.3,3.9,9.2,1.9.9,4.1-.2,5.6-1.6,2.3-.7,4.1-.2,4,2.5-.1,5.5.7,11.1.4,16.7,0,.6,0,1.3-.4,1.9-2.3,2.3-5.7,3.7-7.5,6.4-.2.4-.3.8-.1,1,1,1.1,2.5,2,3.8,2.8,3.4,2.1,8.8,4.6,11.5,6.1,4.3,0,8.6,0,12.8-.2,2.2,0,4.3-.8,6.6-.3,2.6.4,3.5,3.4,3.7,5.6.2.9.6,1.6,1.5,1.9,1.9.7,4.4-.3,6.4.5,3.6,1.4,7.8,5,6,9.2-.3,1.2,0,2.7,1.2,3.1l-.4,1.4h0Z"
              />
              <path
                class="st33"
                d="M352.8,285c-3.1-.6-5.3-3.6-9.4-8.9-1.4-1.9-3.1-4.1-5.1-6.6-7.7-9.6-7.5-14.7-7.5-14.9h2c0,0,0,4.7,7.1,13.6,2,2.5,3.6,4.7,5.1,6.6,3.8,5,5.8,7.7,8.1,8.2l-.4,2h0Z"
              />
              <path
                class="st33"
                d="M660.8,227.3c-4-1.5-6.2-5.3-9.1-8-3.1-2.4-7.5-2.5-11.2-1.7-3.8.2-6.8-2.9-7.7-6.3l-.4-1.4h0c.3-1.6-.2-3.4-1.8-4-1.5-.7-3.3-.4-4.9-.6-5.1-.5-10.2-1.4-15.2-2.5-3.3-.8-6.8-1.7-9.6-3.7-1.2-.9-3-2.9-3.4-3.7-5.6-2.6-11.4-4.7-16.9-7.6-.5-.3-.9-.5-1.3-.9-1.1-1.2-.8-3.1-1.1-4.6-.3-1.8-.2-4.4-1.8-5.4-2.2-1.2-3.6.1-4.7,2-.5.8-1,1.9-1.9,2.5-.9.6-2.1.5-3.1.2-2-.7-3.7-2.1-5.1-3.5-3-2.8-6.1-5.5-9.2-8.2-1.6-1.3-3.1-2.6-4.8-3.8s-3.8-1.4-5.8-1.9c-2.7-.7-7.9-1.7-10.5-2.7-2-1.5-3.4-3.9-4.4-6.3-.8-1.9-1-4-.8-6.1-.4-2.3-1-4.8-2.5-6.7,1.6,1.9,2.1,4.4,2.6,6.7-.5,4.1,1.3,8.2,4,11.2.6.9,1.6,1.2,2.6,1.5,1.9.6,7,1.6,9,2.1,2,.5,4.1.8,5.8,1.9,1.7,1.2,3.3,2.5,4.9,3.8,3.1,2.6,6.2,5.4,9.2,8.2,2,1.8,5,4.6,7.8,3.2.8-.5,1.2-1.5,1.8-2.4,1.2-2,2.8-3.5,5.2-2.2,1,.5,1.4,1.7,1.6,2.7.5,2,.5,4.1.9,6.1.1,1.1.9,1.6,1.8,2.1,5.4,2.8,11.3,4.9,16.9,7.4,1.1,1.3,2.1,2.8,3.5,3.7,2.8,1.9,6.1,2.8,9.4,3.5,5,1,10,1.9,15.1,2.4,1.7.2,3.5-.1,5.2.7.8.4,1.6,1.1,1.9,2,.4.9.4,1.8.3,2.7v-.2l.4,1.4c.9,3.1,3.5,5.9,6.9,5.7,3.6-.8,8.6-.8,11.9,1.8,1.6,1.3,2.6,3.1,4.1,4.5,1.3,1.3,2.9,2.7,4.7,3.3l-.3,1h0Z"
              />
              <path
                class="st33"
                d="M302.8,207.6c-3.5-.6-5.5,2.2-5.9,5.4-.6,1.8-1.6,3.7-3.3,5-1.4,1.2-3.4,1.8-5,2.4-2.8,1.4-5,4.7-6.7,7.4-1.5,2.1-4.6,4-7,2.2-.7-.5-1.2-1.2-1.7-2-2.8-4.8-2.7-10.2-4.2-15.3-.3-.7-.5-1.1-1-1.7-3.2-3.6-4.2-8.6-3.9-13.2,0-1.5.3-3,.4-4.5,0-2.9-.9-5.7-2.8-7.9-.8-.9-2.1-2-3.2-2.4,0,0,0,0-.1,0h-.2c-2.1.4-4.2.9-6.4.6-3.4-.5-3.7-3.4-2.5-6.1,1.6-1.9,4.8-6.8.1-6.6h.3c-2.9,1.5-6.2,2.1-9.4,1.9-3.2-.2-6.2-1.5-9.2-2.4-4.5-1.4-9.2-2.7-13.3-5.1-1.4-.8-2.7-1.9-3.6-3.3h.1c-3.9-2-8.1-3.8-12.5-4.6-2.9-.7-4.5-3.5-3.4-6.3.3-.9.8-1.8,1.2-2.6.6-1.4.8-2.9.5-4.4-.6-5.4-6.7-6.7-9.9-10.6-1.6-1.8-3.9-4-3.4-6.7.4-1.2,1.6-2.1,2.5-3,1.3-1.3,3-2.4,3.3-4.3.1-1.9-1.3-3.4-2.1-5.1-1.2-2.1-2-4.7,1.1-5.6l.9-.2h0c2-1.5,4.8-3.6,4.3-6.5-.1-.4-.2-.7-.5-1-1.6-1.8-2.8-4-4.8-5.3-1.5-.9-3,.3-4.6.5-3.5.5-3.8-2.1-2.8-4.8.9-3.1,1.2-6.3,1.1-9.5.2,3.2,0,6.4-1,9.5-.9,2.6-.8,5.2,2.7,4.7,1.5-.2,3.1-1.4,4.7-.5,2,1.3,3.3,3.5,4.9,5.3.3.3.4.7.6,1.1.5,3-2.3,5.2-4.4,6.8-2,.4-3.6,1.3-2.6,3.7.8,2.4,3.1,4.3,2.9,7-.3,2-2.1,3.2-3.4,4.6-.8.8-1.9,1.7-2.3,2.8-.4,2.4,1.8,4.6,3.3,6.2,1.8,1.8,3.8,3.3,5.9,4.6,3.7,2.1,5.5,7.1,3.8,11.1-.9,1.8-2.1,4-1.1,5.9.5,1,1.8,1.7,2.7,2,4.5.8,8.8,2.6,12.8,4.8,1,1.4,1.9,2.2,3.5,3.1,4.1,2.3,8.6,3.6,13.1,4.9,3,.8,5.9,2.1,9,2.3,3,.2,6.2-.5,8.8-1.9h.1c1,0,2.1,0,2.9.7,1.7,1.5.5,3.9-.4,5.5-.4.8-.9,1.5-1.5,2.2v-.2c-.2.7-.4,1.4-.4,2-.3,2.4,2.4,2.6,4.2,2.4,1.1,0,2.2-.3,3.3-.5.4,0,1-.2,1.4-.1,4.7,1.6,7.2,6.8,7.2,11.5-.1,3-.6,5.9-.2,8.9.4,2.9,1.5,5.6,3.5,7.7,1.1,1.1,1.7,2.9,2,4.4.8,4.1,1.3,8.1,3.1,11.8.6,1.2,1.6,3,3.2,2.7,3.1-.7,4.1-4.4,6.2-6.5,1.2-1.4,2.4-2.8,4.3-3.7,1.7-.6,3.2-1,4.6-2.1,1.2-1,2-2.4,2.6-4,.3-2.3,1.8-5.9,5.1-6.7,1-.3,2-.4,3.1-.2l-.4,1.9h0Z"
              />
            </g>
            <g className="road small-road">
              <path
                class="st28"
                d="M535.3,353.4s3.8-3,2.5-12.6c0,0,1.5-5.3,5.1-7.1s7.2-9.5,8.3-10.5,6.8-4.8,11-.8,5.2,4.2,5.2,4.2"
              />
              <path class="st28" d="M542.3,314s-.1,8.7,12.6,9.9" />
              <path class="st28" d="M534.6,321.2s7.4.4,7.8-6.4" />
              <path class="st28" d="M535.5,321.2s5.7,1.4,7.2,6.9" />
              <polyline
                class="st28"
                points="311.7 395.4 310.7 391.5 275.6 389.8 123.8 306 137.5 349.8 142.7 362.9 179.1 414.1"
              />
              <line class="st28" x1="277.2" y1="390.1" x2="289" y2="410.1" />
              <polyline
                class="st28"
                points="200.3 273.8 196.6 303.7 169 330.7 166.5 340 195.5 442.3"
              />
              <path
                class="st28"
                d="M118.6,290.7s6.3,6,9.7,11.6c2.7,3.3,11.6,2.7,15.6,3.2s70.2,5.9,70.2,5.9l27.2,2.5,16.5-14.5,8.9,5.4,13.3-1,7.6,1,10.5-3.8,26.7,3"
              />
              <path
                class="st28"
                d="M196.4,304l48.4,28.6,20.5,19.8,17.9-18.7,4.2,3.6s23.1-24.2,25.3-25.3,16.5-5.3,16.5-5.3"
              />
              <path
                class="st28"
                d="M287.4,337.4l29.8,28,23.2,12.2s2.1-6,13.8-7.4c-6.7-12.4-15.1-29.1-15.1-29.1,0,0-7.7-.6-12.9-1.1s-7.1,7.3-7.1,7.3c0,0-2.9,8.2-7.7,11.6l-.7.6"
              />
              <path
                class="st28"
                d="M352.7,316.4s-8.1,2.9-9,8.3,1.9,12.2-4.5,16.3"
              />
              <path
                class="st28"
                d="M354.2,370.1s-1.2,10.7,1.6,14.9,10.3,20.3,10.1,22.1c-3.9.5-12.4,2-24.4-4"
              />
              <path
                class="st28"
                d="M339.4,389.6s7.5,10.1-1.7,19.1c-5.9-4-9-5.7-11.4-9.1s-3.7-6.3-3.7-6.3"
              />
              <polyline
                class="st28"
                points="13.9 338.7 21.5 344.8 70 315.7 102.7 303.9 121.5 300.9"
              />
              <path
                class="st28"
                d="M29.2,266.8l4.7,1.1s22.8,16.9,38.8,20.4,36.3,8.5,36.3,8.5l5.1,5.3"
              />
              <polyline
                class="st28"
                points="20 344.1 40 420.8 44.1 425.8 62.6 425.8 83.6 428.3 92.2 431.7 109.9 435.4 114.2 443.2"
              />
              <polyline
                class="st28"
                points="244.4 372.5 240.1 379.9 139.5 436.6"
              />
              <path
                class="st28"
                d="M112.5,442.2s4.5-8,17.2-6.7,31.3,3.6,34.1,3.4,49.1-8.8,49.1-8.8l-7.3-30.3,20,.2-4.1-9.2"
              />
              <line class="st28" x1="254.8" y1="430.6" x2="282.3" y2="398.6" />
              <line class="st28" x1="244.7" y1="405.9" x2="265.5" y2="384.3" />
              <polyline
                class="st28"
                points="212.9 430 226.1 427.4 249.2 417.5"
              />
              <line class="st28" x1="212.3" y1="441.8" x2="255.5" y2="430.2" />
              <line class="st28" x1="66.5" y1="193.9" x2="93.5" y2="237.4" />
              <path
                class="st28"
                d="M147.3,35.6l12.8-9.8-.9-10.2s-8.1-3.2-13.9-2.1"
              />
              <polyline class="st28" points="159.1 15.6 179.1 18.6 233.8 5.7" />
              <path
                class="st28"
                d="M252.7,7.8s1.1,8.4,6,18.9c4.9,10.5,8,18.7,4.5,25.8s-9.7,18.7-15.9,23.7c-6.2,6.4-15.9,28.4-15.3,37s.6,7.5.6,7.5l6.9,8.6s4.1,3.7,1.3,13.1l-4.1,38.5-8,25.8,20.5,49.6-13,17.8"
              />
              <path
                class="st28"
                d="M154.2,80.1l12.7-4.6s5.6,14.9,5.6,19.3,1.2,15.1,1.2,15.1c0,0-1.8,11.7-1.4,18.5s.8,13.7.8,13.7"
              />
              <polyline
                class="st28"
                points="404.2 6.7 402 46.2 436.9 48.1 451.3 54.6 434.4 89.2 426 96.8 433.6 104.2"
              />
              <polyline
                class="st28"
                points="402 46.2 401.5 63.3 396.6 72.9 413.7 81.8 426.7 96.2"
              />
              <polyline
                class="st28"
                points="411.2 7.2 421.2 16 473.1 17 478 21.3 483.4 12.6 479.2 7.7"
              />
              <path
                class="st28"
                d="M458,7.4s-18,23.1-21.2,40.6l-1.7,4.4-21.4,29.3"
              />
              <polyline
                class="st28"
                points="396.6 72.9 384.5 94.2 380.3 121.7"
              />
              <path
                class="st28"
                d="M242,240.1c-7.4-2.8-28-10.6-35.6-17.2s-14.9-9-14.9-9l-38.4-8.8-14.2-11.4-28-18.5-10.9-3.1"
              />
              <path
                class="st28"
                d="M215.6,142.7l-9.5,9.2s-4,5.3-4.5,14-2.4,25.3-2.1,29,1.6,15.3-.5,22.4"
              />
              <path class="st28" d="M133.8,190.5s37.2-20.1,67.8-26.6" />
              <path
                class="st28"
                d="M157.8,142.7l18.2,19.3s44.1,23.5,55.7,34.8"
              />
              <polyline class="st28" points="113.7 274 126.6 263 153.1 205.1" />
              <polyline
                class="st28"
                points="36.2 406.2 83.2 383.2 137.5 349.8 150.9 340.3 156.4 324.4"
              />
              <polyline
                class="st28"
                points="240.1 379.9 241.6 383.2 225.6 399.9 244.7 405.9 254.8 430.6 258.9 437.9"
              />
              <line class="st28" x1="225.6" y1="399.9" x2="203.1" y2="431.7" />
              <path
                class="st28"
                d="M155.1,380.3l-15.6,22.9s-7.1-5-12.7-7.1-8.7-.8-8.7-.8l-35.1-12.1,10.5,44.3-3.4,14.8"
              />
              <path
                class="st28"
                d="M574.8,228.6s12.4,15.7,14.1,32.1c4.3,8.4,15.7,15.7,19.8,35.2,10-.7,23.1-4.4,23.1-4.4l19.1-11,3.7-9-13.4-33.5s6-28.1-1.3-42.2c13.4-31.1,26.5-54.9,30.1-78.3l3-5-16.7-26.8s-2.7-35.5-10-42.9"
              />
              <path
                class="st28"
                d="M457.3,239.9s16-1.5,22,4.5,14,16.7,20.7,40.4,10.7,36.9,10.7,36.9l2.6,8.9-.5,6.6,41-2.1,11.3-.9,16.3-2.9"
              />
              <path
                class="st28"
                d="M612.2,344.3l-4,4.9-22.3,10.3s-7.1-13.1-5.7-15.7,3.4-5.7,3.4-5.7l-2.3-6.6,4.2-16.2,23-19.3"
              />
              <polyline
                class="st28"
                points="631.7 291.5 648.4 289.3 659 294.7 681.5 331 681.9 340.7 688.5 339 688.5 336.5"
              />
              <line class="st28" x1="681.3" y1="331" x2="689.5" y2="330.3" />
              <polyline class="st28" points="351.7 364 394 340.6 432 332.4" />
              <line class="st28" x1="385" y1="345.6" x2="395" y2="364.2" />
              <line class="st28" x1="365.4" y1="379.4" x2="381.2" y2="312.4" />
              <path
                class="st28"
                d="M160,25.8s-1.8,5,9.6,4.8c5.8.6,8.4.6,8.4.6l.9,2.8,34.2,20,9.9,2.4,23.6-6.7,17.8-7.7"
              />
              <path
                class="st28"
                d="M544.6,144.8s10.1-.1,21.8,14.3c9.4,9,11.7,11.1,11.7,11.1l-9.7,10"
              />
              <path
                class="st28"
                d="M557.7,141.4s4.2,5.5,6.6,9,11.2,15.2,11.2,15.2c0,0,10.7-1.1,14.2-3.9s9.1-2.5,9.1-2.5"
              />
              <path
                class="st28"
                d="M639.7,195.8s-13.1,7.8-23.2-.8-17.3-20.4-17.3-20.4l.7-53.5,3.7-12.5,1.5-8.8,7.9-10.8-6.9-4.9"
              />
              <path
                class="st28"
                d="M608.1,81.4l6.6,3.5,3.4-4.8,8.1-1.1s1.7,6.5,8.3,9.1c-4.1,7.4-5.9,13.8-5.3,21.1"
              />
              <path
                class="st28"
                d="M603,109.7l3.7-3.4s13.5-2.8,15-2.4,5,.8,6.5,6.2,4.8,10.5,9.4,12.5c3.9,1,9.5,1.7,12.5-2s5.3-7.9,7.7-7.4,12,4.2,12,4.2"
              />
              <path
                class="st28"
                d="M622.8,104.3s8-.3,10.4.8,5.6,4.6,8.6,2.1c1.5-1.3,2.5-2.6,3-3.4s1.4-1.5,2.4-1.7c2.5-.5,6.7-1.4,7-1.4s3.6.5,4.9.8c.4,0,.8,0,1.1,0l5.2-.8"
              />
              <line class="st28" x1="626.3" y1="57.2" x2="655.7" y2="78.5" />
              <line class="st28" x1="550" y1="140.7" x2="557.7" y2="150.6" />
            </g>
            <g className="road secondary-road">
              <path class="st25" d="M159.4,141.6s.5-16.7-1-35.4" />
              <path class="st25" d="M255.3,441.9s.9-1.2,6.8-6.7l1.6-1.6" />
              <path class="st25" d="M548.7,20.3s-27.1-7-37.2-13.5" />
              <path class="st25" d="M881.6,25.4s.5-.8-12.7,6.6l-5.3,3" />
              <path class="st25" d="M730.1,187s18.7-11.9,15.5-28.6l-3.3-16.7" />
              <path
                class="st25"
                d="M151.6,55.2c0-3.7-.4-7.3-1.5-10.8-4.3-13.6-7.6-21.1-5.8-28,2-7.9,4.6-8.9,4.6-8.9"
              />
              <path
                class="st25"
                d="M1,73.4s5.3-2.5,10-3.6c3-.7,5.3-3,6.1-5.9,4-14.4,9-24.8,8.8-28.3-.2-3.9-1.2-26.8-1.2-26.8"
              />
              <path
                class="st25"
                d="M420.4,350.2c1.3-.7,2-1,2-1,0,0,8.2-1.7,11.1-18.4s5.6-32.7,8.9-39.4"
              />
              <path
                class="st25"
                d="M293.3,407.1c1.5-1.1,3-2.1,4-3.7,1.6-2.7,5-6.8,11.6-7.9,10.1-1.7,37.5-5.8,51.3-13.3,6.2-3.4,12-6.4,24.6-13.1"
              />
              <path
                class="st25"
                d="M670.2,346c5.9,1.2,6.6,1.3,8.2,1.5,0,0,9.1,2.8,30.6,2.4s71.5-2.7,80.6-2.2,20.4.1,34.7,4.2c0,0,21,4.2,27.6,7s28.7,12.9,28.7,12.9"
              />
              <path
                class="st25"
                d="M497.9,321.8s35.8-1.5,44.5,0c3.7.6,13.6,2.3,29.8,5.1"
              />
              <path
                class="st25"
                d="M760.6,53.3c4-.5,5.3-.8,8.1-2,10.1-4.7,20.4-7.7,32.6-8.2,3-.1,6.9-.3,11.1-.6"
              />
              <path
                class="st25"
                d="M693.9,21.7s2.1,5.8,4.5,8.4,28.9,20.1,37.6,22.7c0,0,2.1.3,5.4.6"
              />
              <path
                class="st25"
                d="M833.2,76.2c1.9,1.4,2.3,1.7,4.3,2.9,5.8,3.7,14.5,15.3,16.4,17.8s2.2,12.1,11.2,16.4c10,4,17.2,5.9,17.2,5.9"
              />
              <path
                class="st25"
                d="M795.3,43.6s7.1-.2,15.3,6.4c4.6,4.2,7.7,8.7,9.9,12.2"
              />
              <path
                class="st25"
                d="M808.4,48.3s-.1-10.5-4.2-18.5c0,0-.1-10.5.1-14.8s.1-8.2.1-8.2"
              />
              <path
                class="st25"
                d="M545.9,30s11.6,1.8,18.1,6.7c2.2,1.7,5,2.6,7.8,2.7,1.9,0,4.1.1,6.1.1.8,0,1.6.1,2.4.4,5.7,1.8,14.1,4.9,19.8,4,6.1-.9,27.8-3.4,31.7-2.3s8.4,2.8,8.4,2.8"
              />
              <path
                class="st25"
                d="M647.1,41.5s2-9.5,1.2-15.5c-.6-1.8-1.6-3-2.4-3.7-1.1-.8-1.8-2-2.4-3.2-2-4.5-4.8-11.9-4.8-11.9"
              />
              <path
                class="st25"
                d="M576.5,227.5c3.3-4,1-1,2.2-2.8,4.9-7.2,12.6-18.7,14.4-19.5"
              />
              <path
                class="st25"
                d="M448.8,441.2s39.3-39.1,50-50.7,37.6-37.4,40.4-41.1,4.4-5.3,3.7-21.2-.7-44.2-1.9-55-3.7-16.9,0-18.8c.4-.2,1-.6,1.8-1.1"
              />
              <path
                class="st25"
                d="M599.9,210.6s-24.4-22.8-29.3-27.8-15.3-16.1-17.7-17.4-17.2-3.7-19.2-6.8-3.4-5.7-3.4-5.7"
              />
              <path
                class="st25"
                d="M736,52.7s-1.5,8.5-6.5,13.6c-.6.6-1,1.3-1.5,2-4.7,7.8-10.4,19.5-11.5,26-.9,5.6-4.2,18.1-6.7,25.2s-5.3,16.3-1.1,31.1l1.2,4.9c.4,1.8,1.1,3.5,2,5.1,3.6,6.3,13.5,22.9,23.5,32.5,12.6,12,21.3,20.2,21.3,20.2"
              />
              <path
                class="st25"
                d="M708.4,149s64-13.7,70.2-14.2,15.5.6,27.9-7.1,14-9.3,27.2-6.3c7.7-4.2,24.9-13.3,24.9-13.3"
              />
              <path
                class="st25"
                d="M496.3,393.7l-8.2-6.6s-2-2-10-2h-13.1s-2.9.9-6.1-3.4c-13.1-15.8-30.6-36.6-30.6-36.6"
              />
              <path
                class="st25"
                d="M44.5,217.3s17.8,12.9,30.4,15.5c12.5,2.6,18.7,3.7,22.7,7.8,0,0,7.9,6.8,9.7,11.7s12.2,41.1,12.2,41.1c0,0,2.9,10.2,5.1,12.8"
              />
              <path
                class="st25"
                d="M432.4,333.2s23.9-10,43.1-10.7,53.8-1.7,66.9-.7"
              />
            </g>
            <g className="road main-road">
              <line class="st25" x1="1.6" y1="97" x2="65.8" y2="193" />
              <path class="st32" d="M529.1 127.4 L540.4 129.1 L550.7 140.8" />

              <path class="st32" d="M462,109.6c20.9,6.5,46.6,14.2,46.6,14.2" />
              <path
                class="st32"
                d="M293.6,147.9c14.7,2,25.2,3.7,28.7,3.3,8-.8,43.8-22.5,43.8-22.5,0,0,16.9-11.2,43-15.7,0,0,23.7-12.8,32.5-10"
              />
              <path
                class="st32"
                d="M6.8,445.1s-8.4-34.9-.8-69.1c7.6-34.1,24.5-114.4,24.5-114.4,0,0,1.6-28.9,17.7-49.4,0,0,22.1-26.5,40.2-34.1s71.1-36.5,71.1-36.5c0,0,43.8,1.2,73.5.8,11.3-.1,25.8,1.2,39.8,2.9"
              />

              <path class="st32" d="M691.4,23.8c3.8-3.3,16-15.2,17.2-17.4" />
              <path
                class="st32"
                d="M328.6,7.1s4.7,26.8-15.2,44.3c0,0-16.2,16.1-21.7,27.2-1.4,2.9-1.8,6.2-1.2,9.4,1.2,6.2,4.6,17.9,13.9,25.8,0,0,2.7,4.3,19.8,6.2,2.3.2,4.5.8,6.7,1.7,3.1,1.3,7.7,3.2,9.4,3.7,2.7.7,12.3-1.3,15.6,3.1,3.3,4.3,6.1,9.8,5.4,12.7s-6.8,20.9-13.6,30.6c-4.7,6.3-4.2,18.8-4.2,18.8,0,0,1.6,4.9-6.9,12.7-5.1,6.5-5.1,8.5-4.5,13.9s.9,21.5.2,25.7-4.9,42-4.9,42c0,0-3.1,6.5-1.8,20.3,2.2,2.4,14.5,5.2,20.6,9.4s15.1,1.8,27.7-.7,55.4-10.4,58.5-12.7,10.9-6.5,13.9-19.8,4.1-27.4,8.4-35.9c8.4-14.9,31.1-59.9,38.4-67.5s49.4-32.2,49.4-32.2c0,0,27.3-16.2,30.3-18.3s13.4-14.9,19.3-23.8,29.1-40.8,32.1-44.8,9.6-14.2,27.1-18.4c7.3-2.3,15.2-5.2,22.2-8"
              />

              <path
                class="st32"
                d="M237.3,273.3s23.5-13.5,34.2-16.1,69.1-18.8,75.7-21.2c0,0,8-1.7,25.2-18.2,0,0,10.6-10.6,17.1-12.1s22.2-4.2,26.2-10.6c3-4.8,11.5-20.2,15.6-27.6,1.3-2.4,2-5.1,2-7.9,0-4.1.4-10.3,3.5-13.6,4.7-5.1,12.3-11.2,20.7-13.9,5.3-4.9,5.7-6.1,8.2-15.6,0,0,6.6-21.2,15.8-30.4s14.8-19,42.9-23.2c9.1-2.7,11.6-1.5,15.2-11.8s13.3-45,14.6-46.1"
              />

              <line class="st25" x1="496.3" y1="393.7" x2="535.8" y2="428.4" />

              <path class="st32" d="M540.9,129.3s9,7.8,19.2,5.7" />
            </g>
            <path
              data-name="ql"
              class="st29 ql moving-line"
              d="M328.6,7.1s4.7,26.8-15.2,44.3c0,0-16.2,16.1-21.7,27.2-1.4,2.9-1.8,6.2-1.2,9.4,1.2,6.2,4.6,17.9,13.9,25.8,0,0,2.7,4.3,19.8,6.2,2.3.2,4.5.8,6.7,1.7,3.1,1.3,7.7,3.2,9.4,3.7,2.7.7,12.3-1.3,15.6,3.1,3.3,4.3,6.1,9.8,5.4,12.7s-6.8,20.9-13.6,30.6c-4.7,6.3-4.2,18.8-4.2,18.8,0,0,1.6,4.9-6.9,12.7-5.1,6.5-5.1,8.5-4.5,13.9s.9,21.5.2,25.7-4.9,42-4.9,42c0,0-3.1,6.5-1.8,20.3,2.2,2.4,14.5,5.2,20.6,9.4s15.1,1.8,27.7-.7,55.4-10.4,58.5-12.7,10.9-6.5,13.9-19.8,4.1-27.4,8.4-35.9c8.4-14.9,31.1-59.9,38.4-67.5s49.4-32.2,49.4-32.2c0,0,27.3-16.2,30.3-18.3s13.4-14.9,19.3-23.8,29.1-40.8,32.1-44.8,9.6-14.2,27.1-18.4c7.3-2.3,15.2-5.2,22.2-8"
            />

            <path
              id="ql1"
              data-name="ql"
              class="st29 ql moving-line"
              d="M691.4,23.8c3.8-3.3,16-15.2,17.2-17.4"
            />
            <g id="PARK">
              <path
                class="st0"
                d="M151.9,210.7l14.4.8c.6,0,1,.5.9,1.1l-.8,12.5c0,.3.1.6.3.8l1.2,1.1c.3.3.8.4,1.2.1,1.9-1.1,7.5-4.2,9.2-1.6.1.1.1.3.1.5,0,5.5,0,10.7,0,12.6,0,.4-.2.8-.6.9l-25.4,10.2c-.2.1-.5.1-.8,0l-10.8-4.7c-.5-.2-.7-.8-.5-1.3l6.6-16.1c.2-.5,0-1.1-.5-1.3l-.9-.4c-.5-.2-.7-.8-.5-1.3l5.8-13.1c.2-.4.6-.6,1-.6h0Z"
              />
              <path
                class="st0"
                d="M626.1,125.6s3.8,1.2,6.6,8.2c3.1,5.6,8,14.1,13.5,17.3s-2.7,14.1-3.2,20.7-8,10.8-10.2,11.4-8.2,3-11.2-4.7-6.8-13.3-7.4-16.4-3.4-22.5-2-26.9c4.6-2.2,7.7-2.2,9.7-5.6s3-5.6,4.2-4.1h0Z"
              />
              <path
                class="st0"
                d="M168.3,397.2s0-3.6,2.6-4.1,6.8-1.5,8.2-.5,3.8,4,3.9,5.3-2.8,1.9-1.6,3.4,3.2,3.4,1.2,5.6-4.9,2.8-6,1-2.7-1.1-3.6-2.4-4.8-8.2-4.8-8.2h0Z"
              />
              <path
                class="st0"
                d="M225.4,271.2l2.6-.9s8.4,1.6,9.1,2.6-1.3,13.4-1.3,13.4c0,0-7.4,1.5-10.3,1.5s-3.6,1.1-6.4.4-4.7,0-5.4-1.4-1.2-2.5-.7-4.5-1.3-3.2.9-4.5,3.2.5,5-.8,1.1-1.6,2.1-3.4,1.3-1.5,2.6-1.9,1.8-.5,1.8-.5h0Z"
              />
            </g>
            <g className="airport-road">
              <line class="st30" x1="200" y1="241.1" x2="119" y2="273" />
              <line class="st30" x1="118.8" y1="282.2" x2="219.5" y2="244.2" />
              <path
                class="st30"
                d="M126.2,270.2s-2.5,5.2-.8,9.1c.1.2.2.5.2.8.5,2.5,1.2,3.9,1.9,4.8.7.9,1.9,1.2,3,.8l78-29.6c1.7-.7,3.9-1.5,5.2-2.9,1.1-1.3,1.7-2.8,1.6-3.6-.2-1.3-2.5-2.7-3.7-2.4"
              />
              <path
                class="st30"
                d="M145.7,262.5s-6.6,6.3-2.8,10.6c0,0,.9,5.6,5.2,5.8"
              />
              <path class="st30" d="M172.2,262s6.8.4,10.1,3.8" />
              <line class="st30" x1="190.4" y1="245" x2="188.7" y2="263.5" />
            </g>
            <g id="Name">
              <g class="city-name st16">
                <g class="st13">
                  <text class="st8" transform="translate(90.9 347.5)">
                    <tspan x="0" y="0">
                      TP
                    </tspan>
                  </text>
                  <text class="st8" transform="translate(59.8 365.5)">
                    <tspan x="0" y="0">
                      Hồ Chí Minh
                    </tspan>
                  </text>
                </g>
              </g>
              <g class="city-name st16">
                <text class="st8" transform="translate(419.8 29.3)">
                  <tspan x="0" y="0">
                    TP
                  </tspan>
                </text>
                <text class="st8" transform="translate(411.7 47.3)">
                  <tspan x="0" y="0">
                    Dĩ An
                  </tspan>
                </text>
              </g>
              <g class="city-name st16">
                <text class="st8" transform="translate(319.9 68.4)">
                  <tspan x="0" y="0">
                    TP
                  </tspan>
                </text>
                <text class="st8" transform="translate(297.5 86.4)">
                  <tspan x="0" y="0">
                    Thuận An
                  </tspan>
                </text>
              </g>
              <g class="st13 city-name">
                <text class="st14" transform="translate(780.5 198.9)">
                  <tspan x="0" y="0">
                    Đồng Nai
                  </tspan>
                </text>
              </g>

              <g class="st13 amenity landmark">
                <path
                  class="st24"
                  d="M348.5,317.4v-8.1h-.7v-17.1h-.7v-8.4h-1v-5.8h-1.2v5.8h-.9v5h-.4v3.3h-.3v8.8h-.5v8.5h-.3v8.1s5.8,0,5.9,0h0Z"
                />
                <text class="st22" transform="translate(327.8 324.4)">
                  <tspan x="0" y="0">
                    Landmark 81
                  </tspan>
                </text>
              </g>

              <g class="st13">
                <text
                  class="st23"
                  transform="translate(701.8 176.9) rotate(55)"
                >
                  <tspan x="0" y="0">
                    Sông Đồng Nai
                  </tspan>
                </text>
              </g>
              <g class="st13 mai-chi-tho road secondary-road secondary-road-name">
                <text
                  class="st22"
                  transform="translate(387.8 369.9) rotate(-28.2)"
                  letterSpacing={'-0.5px'}
                >
                  <tspan x="0" y="0">
                    MAI CHÍ THỌ
                  </tspan>
                </text>
              </g>
              <g class="st13 cao-toc-long-thanh road secondary-road secondary-road-name">
                <text
                  class="st22"
                  transform="translate(573.7 329.3) rotate(10.7)"
                  letterSpacing="-0.5px"
                >
                  <tspan x="0" y="0">
                    CAO TỐC LONG THÀNH - DẦU GIÂY
                  </tspan>
                </text>
                {/* <text
                  class="st22"
                  transform="translate(577.6 330) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    A
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(581.5 330.8) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    O
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(585.5 331.5) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    {' '}
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(586.8 331.8) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    T
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(590.4 332.5) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    ỐC{' '}
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(599.8 334.2) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    L
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(602.8 334.8) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    ONG
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(615 337.1) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    {' '}
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(616.3 337.4) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    T
                  </tspan>
                </text>
                <text class="st22" transform="translate(620 338) rotate(10.7)">
                  <tspan x="0" y="0">
                    H
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(624.2 338.8) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    ÀNH -{' '}
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(641.7 342.1) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    D
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(645.5 342.9) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    Ầ
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(649.4 343.6) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    U G
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(658.8 345.4) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    I
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(660.6 345.7) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    Â
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(664.1 346.4) rotate(10.7)"
                >
                  <tspan x="0" y="0">
                    Y
                  </tspan>
                </text> */}
              </g>
              <g class="st13 road secondary-road secondary-road-name vo-chi-cong">
                <text
                  class="st22"
                  transform="translate(546 253.3) rotate(-36.8)"
                  letterSpacing={'-0.5px'}
                >
                  <tspan x="0" y="0">
                    VÕ CHÍ CÔNG
                  </tspan>
                </text>
              </g>
              <g class="st13 road secondary-road secondary-road-name">
                <text class="st22" transform="translate(820 65.4) rotate(47.8)">
                  <tspan x="0" y="0">
                    QL51
                  </tspan>
                </text>
              </g>
              <g class="st13 road secondary-road secondary-road-name">
                <text
                  class="st22"
                  transform="translate(743.4 55.8) rotate(-.1)"
                >
                  <tspan x="0" y="0">
                    QL51
                  </tspan>
                </text>
              </g>
              <g class="st13 road main-road main-road-name">
                <text
                  class="st22"
                  transform="translate(676.2 33.5) rotate(-24.8)"
                >
                  <tspan x="0" y="0">
                    QL1A
                  </tspan>
                </text>
              </g>
              <g class="st13 road main-road main-road-name">
                <text
                  class="st22"
                  transform="translate(510.5 126.7) rotate(8.4)"
                >
                  <tspan x="0" y="0">
                    QL1A
                  </tspan>
                </text>
              </g>
              <g class="st13 road main-road main-road-name">
                <text
                  class="st22"
                  transform="translate(443.7 105.7) rotate(17.6)"
                >
                  <tspan x="0" y="0">
                    QL1A
                  </tspan>
                </text>
              </g>
              <g class="st13 road main-road main-road-name">
                <text class="st22" transform="translate(275 147.5) rotate(7.4)">
                  <tspan x="0" y="0">
                    QL1A
                  </tspan>
                </text>
              </g>
              <g class="st13 vo-van-kiet road secondary-road secondary-road-name">
                <text
                  class="st22"
                  transform="translate(266.3 433.9) rotate(-41.9)"
                >
                  <tspan x="0" y="0">
                    V
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(269.2 431.3) rotate(-41.9)"
                >
                  <tspan x="0" y="0">
                    Õ{' '}
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(273.4 427.6) rotate(-41.9)"
                >
                  <tspan x="0" y="0">
                    V
                  </tspan>
                </text>
                <text
                  class="st22"
                  transform="translate(276.1 425.1) rotate(-41.9)"
                  letterSpacing={'-0.5'}
                >
                  <tspan x="0" y="0">
                    ĂN KIỆT
                  </tspan>
                </text>
              </g>
              <g class="st13 river-name">
                <text
                  class="st23"
                  transform="translate(545.6 435.2) rotate(-36.4)"
                >
                  <tspan x="0" y="0">
                    Soài Rạp
                  </tspan>
                </text>
              </g>

              <g class="st13 river-name">
                <text
                  class="st23"
                  transform="translate(655.3 401.2) rotate(-30.6)"
                >
                  <tspan x="0" y="0">
                    Soài Rạp
                  </tspan>
                </text>
              </g>

              <g>
                <g className="location-pin">
                  <path
                    class="pin-container"
                    fill="#fff"
                    d="M497.8,200.3c-.3-6.9-6-12.5-13-12.5-7.2,0-13,5.8-13.1,13,0,1.8.4,3.5,1,5.1,2.9,7.7,10.8,17,11.9,18,0,0,.2,0,.2,0,1.2-1.1,10.4-11.2,12.5-19.8,0,0,0-.2,0-.2,0,0,0-.2,0-.2.1-.6.2-1.2.3-1.8h0c0-.4,0-.7,0-1s0-.4,0-.5h0Z"
                  />
                  <path
                    class="pin-icon"
                    d="M497.8,200.3c-.3-6.9-6-12.5-13-12.5-7.2,0-13,5.8-13.1,13,0,1.8.4,3.5,1,5.1,2.9,7.7,10.8,17,11.9,18,0,0,.2,0,.2,0,1.2-1.1,10.4-11.2,12.5-19.8,0,0,0-.2,0-.2,0,0,0-.2,0-.2.1-.6.2-1.2.3-1.8h0c0-.4,0-.7,0-1s0-.4,0-.5h0Z"
                    fill="url(#logo-image-pattern)"
                  />
                </g>

                <g class="st39 location-shadow">
                  <ellipse
                    class="st19"
                    cx="484.8"
                    cy="225"
                    rx="14.8"
                    ry="3.5"
                  />
                  <ellipse class="st18" cx="484.8" cy="225" rx="8.8" ry="2.1" />
                  <ellipse class="st10" cx="484.8" cy="225" rx="4" ry=".9" />
                </g>
                <text class="st22 location-name" x="484" y="225">
                  <tspan x="0" y="0">
                    Vizion
                  </tspan>
                </text>
              </g>

              <g class="st13">
                <text
                  class="st1"
                  transform="translate(314.2 172.9) rotate(9.5)"
                >
                  <tspan x="0" y="0">
                    S
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(317.1 173.4) rotate(9.6)"
                >
                  <tspan x="0" y="0">
                    ô
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text class="st1" transform="translate(320.6 174) rotate(3.8)">
                  <tspan x="0" y="0">
                    n
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(324.4 174.2) rotate(-5.6)"
                >
                  <tspan x="0" y="0">
                    g
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(329.7 173.2) rotate(-23.1)"
                >
                  <tspan x="0" y="0">
                    S
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(332.6 172) rotate(-28.3)"
                >
                  <tspan x="0" y="0">
                    à
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(335.3 170.4) rotate(-32.5)"
                >
                  <tspan x="0" y="0">
                    i
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(338 168.8) rotate(-43.1)"
                >
                  <tspan x="0" y="0">
                    G
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(341.4 165.3) rotate(-64.2)"
                >
                  <tspan x="0" y="0">
                    ò
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(343.1 161.6) rotate(-80.2)"
                >
                  <tspan x="0" y="0">
                    n
                  </tspan>
                </text>
              </g>

              <g class="st13">
                <text class="st1" transform="translate(340.3 257) rotate(3)">
                  <tspan x="0" y="0">
                    S
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(343.4 257.2) rotate(-1.2)"
                >
                  <tspan x="0" y="0">
                    ô
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text class="st1" transform="translate(347 257.1) rotate(-6)">
                  <tspan x="0" y="0">
                    n
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(350.5 256.7) rotate(-11.6)"
                >
                  <tspan x="0" y="0">
                    g
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(355.4 255.6) rotate(-20.3)"
                >
                  <tspan x="0" y="0">
                    S
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(358.1 254.5) rotate(-21.1)"
                >
                  <tspan x="0" y="0">
                    à
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(360.8 253.5) rotate(-21.9)"
                >
                  <tspan x="0" y="0">
                    i
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(363.3 252.5) rotate(-23.7)"
                >
                  <tspan x="0" y="0">
                    G
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(367 250.9) rotate(-26.3)"
                >
                  <tspan x="0" y="0">
                    ò
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st1"
                  transform="translate(370.1 249.4) rotate(-29.7)"
                >
                  <tspan x="0" y="0">
                    n
                  </tspan>
                </text>
              </g>

              <g className="le-van-khuong road secondary-road secondary-road-name">
                <g class="st13">
                  <text
                    class="st22"
                    transform="translate(150.7 56.8) rotate(88)"
                  >
                    <tspan x="0" y="0">
                      L
                    </tspan>
                  </text>
                </g>
                <g class="st13">
                  <text
                    class="st22"
                    transform="translate(150.8 60.1) rotate(85.6)"
                  >
                    <tspan x="0" y="0">
                      Ê
                    </tspan>
                  </text>
                </g>
                <g class="st13">
                  <text
                    class="st22"
                    transform="translate(151.2 65.1) rotate(82.4)"
                  >
                    <tspan x="0" y="0">
                      V
                    </tspan>
                  </text>
                </g>
                <g class="st13">
                  <text
                    class="st22"
                    transform="translate(151.7 68.7) rotate(80.5)"
                  >
                    <tspan x="0" y="0">
                      Ă
                    </tspan>
                  </text>
                </g>
                <g class="st13">
                  <text
                    class="st22"
                    transform="translate(152.4 72.7) rotate(78.4)"
                  >
                    <tspan x="0" y="0">
                      N
                    </tspan>
                  </text>
                </g>
                <g class="st13">
                  <text
                    class="st22"
                    transform="translate(153.6 78.3) rotate(77.3)"
                  >
                    <tspan x="0" y="0">
                      K
                    </tspan>
                  </text>
                </g>
                <g class="st13">
                  <text
                    class="st22"
                    transform="translate(154.4 82) rotate(81.1)"
                  >
                    <tspan x="0" y="0">
                      H
                    </tspan>
                  </text>
                </g>
                <g class="st13">
                  <text
                    class="st22"
                    transform="translate(155.1 86.1) rotate(83)"
                  >
                    <tspan x="0" y="0">
                      Ư
                    </tspan>
                  </text>
                </g>
                <g class="st13">
                  <text
                    class="st22"
                    transform="translate(155.6 90.3) rotate(84.2)"
                  >
                    <tspan x="0" y="0">
                      Ơ
                    </tspan>
                  </text>
                </g>
                <g class="st13">
                  <text class="st22" transform="translate(156 94.5) rotate(85)">
                    <tspan x="0" y="0">
                      N
                    </tspan>
                  </text>
                </g>
                <g class="st13">
                  <text
                    class="st22"
                    transform="translate(156.4 98.9) rotate(81)"
                  >
                    <tspan x="0" y="0">
                      G
                    </tspan>
                  </text>
                </g>
              </g>

              <g class="st39">
                <ellipse class="st3" cx="185.8" cy="221.3" rx="15.4" ry="3.6" />
                <ellipse class="st5" cx="185.8" cy="221.3" rx="9.1" ry="2.1" />
                <ellipse class="st7" cx="185.8" cy="221.3" rx="4.1" ry="1" />
              </g>
              <g className="chk amenity airport">
                <path
                  class="st24"
                  d="M194.2,211.2c.9,5.8-4,10.8-9.8,9.8-3.5-.6-6.4-3.4-6.9-6.9-1-5.8,4-10.8,9.8-9.8,3.5.6,6.4,3.4,6.9,6.9h0Z"
                />
                <path
                  class="st34"
                  d="M189.4,216.7c.3-.3.4-.6.2-1l-.9-2.7.6-.6c0,0,0-.2,0-.3h-.1c0-.1-.1-.3-.1-.3,0,0-.2,0-.3,0l-.3.3-.3-.8,1.6-1.6c.5-.5.7-1.3.4-1.5s-1-.1-1.5.4l-1.6,1.6h-.4c0-.1-.4-.3-.4-.3l.3-.3c0,0,0-.2,0-.3h-.1c0-.1-.1-.3-.1-.3,0,0-.2,0-.3,0l-.6.6-2.7-.9c-.4-.1-.7,0-1,.2l-.3.3.6.4h0l3.2,1.9.4.2-1.3,1.3c-.3.3-.6.7-.8,1.2h0c0,0-1.4-.2-1.4-.2-.2,0-.4,0-.5.2l-.2.2c0,0,0,.2,0,.3l1.4.7c.1,0,.2.2.3.3l.7,1.4c0,.1.2.1.3,0l.2-.2c.1-.1.2-.3.2-.5l-.2-1.4h0c.4-.3.8-.5,1.2-.9l1.3-1.3,2.1,3.6h0l.4.6.3-.3h0Z"
                />
                <g class="st13 ">
                  <text class="st22" transform="translate(145.1 229.3)">
                    <tspan x="0" y="0">
                      Cảng Hàng Không Quốc Tế
                    </tspan>
                  </text>

                  <text class="st22" transform="translate(166.3 236.5)">
                    <tspan x="0" y="0">
                      Tân Sơn Nhất
                    </tspan>
                  </text>
                </g>
              </g>

              <g className="hospital amenity">
                <g class="st13">
                  <text class="st22" transform="translate(380 143.2)">
                    <tspan x="0" y="0">
                      Bệnh Viện
                    </tspan>
                  </text>
                  <text class="st22" transform="translate(363.1 150.4)">
                    <tspan x="0" y="0">
                      Thành Phố Thủ Đức
                    </tspan>
                  </text>
                </g>
                <path
                  class="st24"
                  d="M404,125.8c1,5.8-4,10.8-9.8,9.8-3.5-.6-6.4-3.4-7-6.9-1-5.8,4-10.8,9.8-9.8,3.5.6,6.4,3.4,6.9,6.9h0Z"
                />
                <path
                  id="medicine"
                  class="st35"
                  d="M400.4,125.3c-.9,1.5-2.5,2.7-4.4,2.8v2.4c.6-.1,1.1-.6,1.5-1.8.2.4,0,1.1,0,1.1-.1.5-.5.9-.9,1.2.7.2,1.2.7,1.6,1.4h-5.4c.3-.6.9-1.1,1.5-1.3-.6-.4-1.1-1.1-1.1-1.9s.2-.9.4-1.3c-1.2-.5-2.3-1.4-3-2.5h8.7c0-.2.1-.4.1-.7,0-1.2-1.1-2.1-2.4-2.1s-1.1.2-1.5.5c0,.4-.3.9-.9,1.2-.7.4-1.5.5-1.7.1s.1-1.1.8-1.5c.5-.3,1.1-.4,1.4-.3.5-.3,1.1-.6,1.9-.6,1.7,0,3,1.2,3,2.6s0,.5,0,.7h.2ZM395.2,128.3c-.5,0-.6,0-.6,0-.3.3-.5.6-.5,1.1,0,.7.5,1.2,1.1,1.4v-2.4h0ZM400.3,125.6h0s0,0,0,0ZM400.3,125.5s0,0,0,0c0,0,0,0,0,0ZM400.4,125.5s0,0,0,0c0,0,0,0,0,0ZM400.4,125.5s0,0,0,0c0,0,0,0,0,0ZM400.4,125.4s0,0,0,0c0,0,0,0,0,0ZM400.4,125.4h0s0,0,0,0ZM400.4,125.4s0,0,0,0c0,0,0,0,0,0ZM400.4,125.3s0,0,0,0c0,0,0,0,0,0Z"
                />
              </g>
              <g class="st39">
                <ellipse
                  class="st20"
                  cx="664.5"
                  cy="158.7"
                  rx="15.4"
                  ry="3.6"
                />
                <ellipse class="st21" cx="664.5" cy="158.7" rx="9.1" ry="2.1" />
                <ellipse class="st4" cx="664.5" cy="158.7" rx="4.1" ry="1" />
              </g>
              <g className="amenity golf-club">
                <g class="st13">
                  <text class="st22" transform="translate(640.1 166)">
                    <tspan x="0" y="0">
                      Vietnam Golf &amp;{' '}
                    </tspan>
                  </text>
                  <text class="st22" transform="translate(642.9 173.2)">
                    <tspan x="0" y="0">
                      Country Club
                    </tspan>
                  </text>
                </g>
                <path
                  class="st24"
                  d="M672.8,148.5c1,5.8-4,10.8-9.8,9.8-3.5-.6-6.4-3.4-7-6.9-1-5.8,4-10.8,9.8-9.8,3.5.6,6.4,3.4,6.9,6.9h0Z"
                />
                <path
                  class="st35"
                  d="M663.1,145c0,.2-.2.4-.3.4-.2,0-.4-.2-.4-.4s.2-.4.4-.3c.2,0,.3.2.3.4h0ZM662.8,154.9c.5,0,.9,0,.9.2,0,.1-.5.2-1.1.2s-1.1,0-1.1-.2.4-.2,1-.2l.2-9.5h.3v9.5q-.1,0-.1,0ZM665.5,146.4c-.9-.4-1.5-1.1-2.4-.6v2.8c0,0,0-.1.1-.2.9-.6,2.1.3,3,.2,1.3-.1,2.4-1.1,3.1-2.7-.7.3-2.2,1.1-3.8.4h0Z"
                />
              </g>
              <g class="st39">
                <ellipse class="st9" cx="810.3" cy="150.9" rx="15.4" ry="3.6" />
                <ellipse class="st15" cx="810.3" cy="150.9" rx="9.1" ry="2.1" />
                <ellipse class="st2" cx="810.3" cy="150.9" rx="4.1" ry="1" />
              </g>
              <g className="amenity golf-club">
                <g class="st13">
                  <text class="st22" transform="translate(778.2 158.3)">
                    <tspan x="0" y="0">
                      Sân Golf Long Thành
                    </tspan>
                  </text>
                </g>
                <path
                  class="st24"
                  d="M818.7,140.9c1,5.8-4,10.8-9.8,9.8-3.5-.6-6.4-3.4-7-6.9-1-5.8,4-10.8,9.8-9.8,3.5.6,6.4,3.4,6.9,6.9h0Z"
                />
                <path
                  class="st35"
                  d="M809,137.4c0,.2-.2.4-.3.4-.2,0-.4-.2-.4-.4s.2-.4.4-.3c.2,0,.3.2.3.4h0ZM808.7,147.3c.5,0,.9,0,.9.2,0,.1-.5.2-1.1.2s-1.1,0-1.1-.2.4-.2,1-.2l.2-9.5h.3v9.5q-.1,0-.1,0ZM811.4,138.7c-.9-.4-1.5-1.1-2.4-.6v2.8c0,0,0-.1.1-.2.9-.6,2.1.3,3,.2,1.3-.1,2.4-1.1,3.1-2.7-.7.3-2.2,1.1-3.8.4h0Z"
                />
              </g>
              <g className="landmark amenity">
                <rect
                  class="st24"
                  x="274.5"
                  y="343.1"
                  width=".2"
                  height="3.1"
                />
                <rect class="st24" x="268" y="346.2" width="13.1" height=".6" />
                <rect
                  class="st24"
                  x="269.2"
                  y="346.8"
                  width="10.8"
                  height=".6"
                />
                <g>
                  <rect
                    class="st24"
                    x="269.8"
                    y="347.4"
                    width=".7"
                    height="1.2"
                  />
                  <rect
                    class="st24"
                    x="272.8"
                    y="347.4"
                    width=".7"
                    height="1.2"
                  />
                  <rect
                    class="st24"
                    x="275.7"
                    y="347.4"
                    width=".7"
                    height="1.2"
                  />
                  <rect
                    class="st24"
                    x="278.6"
                    y="347.4"
                    width=".7"
                    height="1.2"
                  />
                </g>
                <rect
                  class="st24"
                  x="250.3"
                  y="348.1"
                  width="48.4"
                  height="1.3"
                />
                <g>
                  <rect
                    class="st24"
                    x="250.8"
                    y="347.8"
                    width="5.2"
                    height="1.6"
                  />
                  <rect
                    class="st24"
                    x="293"
                    y="347.8"
                    width="5.2"
                    height="1.6"
                  />
                </g>
                <rect
                  class="st24"
                  x="248.4"
                  y="357.5"
                  width="52.2"
                  height="2.1"
                />
                <path
                  class="st24"
                  d="M274.5,343.1v1.6h2.5v-1.6h-2.5ZM276,344.4l-.3-.2-.3.2v-.4c.1,0-.2-.2-.2-.2h.4v-.4c.1,0,.2.4.2.4h.4l-.3.2v.4h.1Z"
                />
                <path
                  class="st24"
                  d="M247.5,349.5v7.9h54.1v-7.9h-54.1ZM249.3,356.5h-.5v-6.1h.5v6.1ZM251.8,356.5h-.5v-6.1h.5v6.1ZM254.2,356.5h-.5v-6.1h.5v6.1ZM256.7,356.5h-.5v-6.1h.5v6.1ZM259.1,356.5h-.5v-6.1h.5v6.1ZM261.6,356.5h-.5v-6.1h.5v6.1ZM264.1,356.5h-.5v-6.1h.5v6.1ZM266.6,356.5h-.5v-6.1h.5v6.1ZM279.6,355.3h-10.2v-.5h10.2v.5ZM279.6,352.2h-10.2v-.5h10.2v.5ZM283,356.5h-.5v-6.1h.5v6.1ZM285.5,356.5h-.5v-6.1h.5v6.1ZM287.9,356.5h-.5v-6.1h.5v6.1ZM290.4,356.5h-.5v-6.1h.5v6.1ZM292.9,356.5h-.5v-6.1h.5v6.1ZM295.3,356.5h-.5v-6.1h.5v6.1ZM297.8,356.5h-.5v-6.1h.5v6.1ZM300.3,356.5h-.5v-6.1h.5v6.1Z"
                />
                <g class="st13">
                  <text class="st22" transform="translate(252.8 366.9)">
                    <tspan x="0" y="0">
                      Dinh Độc Lập
                    </tspan>
                  </text>
                </g>
              </g>

              <g class="st13 vo-nguyen-giap road secondary-road secondary-road-name">
                <text
                  class="st22"
                  transform="translate(814.3 44.1) rotate(-2.6)"
                >
                  <tspan x="0" y="0">
                    V
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st22"
                  transform="translate(818.2 43.9) rotate(-3.2)"
                >
                  <tspan x="0" y="0">
                    Õ
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text class="st22" transform="translate(823.8 43.6) rotate(-4)">
                  <tspan x="0" y="0">
                    N
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text class="st22" transform="translate(828 43.3) rotate(-4.7)">
                  <tspan x="0" y="0">
                    G
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st22"
                  transform="translate(832.1 42.9) rotate(-5.3)"
                >
                  <tspan x="0" y="0">
                    U
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text class="st22" transform="translate(836 42.6) rotate(-6.1)">
                  <tspan x="0" y="0">
                    Y
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st22"
                  transform="translate(839.7 42.2) rotate(-6.9)"
                >
                  <tspan x="0" y="0">
                    Ê
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text class="st22" transform="translate(843 41.8) rotate(-8)">
                  <tspan x="0" y="0">
                    N
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st22"
                  transform="translate(848.6 41) rotate(-10.2)"
                >
                  <tspan x="0" y="0">
                    G
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st22"
                  transform="translate(852.7 40.2) rotate(-11.9)"
                >
                  <tspan x="0" y="0">
                    I
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st22"
                  transform="translate(854.6 39.8) rotate(-14.4)"
                >
                  <tspan x="0" y="0">
                    Á
                  </tspan>
                </text>
              </g>
              <g class="st13">
                <text
                  class="st22"
                  transform="translate(858.7 38.8) rotate(-20.3)"
                >
                  <tspan x="0" y="0">
                    P
                  </tspan>
                </text>
              </g>
            </g>
            <g>
              <circle
                id="circle"
                class="st27 distance-circle circle-5km"
                cx="485.2"
                cy="208"
                r="50"
              />
              <circle
                id="circle1"
                data-name="circle"
                class="st27 distance-circle circle-10km"
                cx="485.2"
                cy="208"
                r="100"
              />
              <circle
                id="circle2"
                data-name="circle"
                class="st27 distance-circle circle-15km"
                cx="485.2"
                cy="208"
                r="150"
              />
              {/* <circle
                id="circle3"
                data-name="circle"
                class="st27 circle circle-20km"
                cx="485.2"
                cy="208"
                r="200"
              />*/}
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
